import React, { useEffect, useState, Fragment, useRef, useCallback } from "react";
import {
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable,
    getFilteredRowModel,
    getPaginationRowModel,
} from "@tanstack/react-table";
import { useVirtualizer } from "@tanstack/react-virtual";
import {
    ArrowPathIcon,
    PencilIcon,
    TrashIcon,
    PlusCircleIcon,
    EyeIcon,
    ArrowDownTrayIcon,
    EllipsisHorizontalIcon
} from "@heroicons/react/24/outline";
// import { useDropzone } from "react-dropzone";
import { initialpageSize } from "../Common/Contants";
import InputModal from "../Common/InputModal";
import Popup from "../Common/Popup";
import ConfirmationPopup from "../Common/ConfirmationPopup";
import axios from "axios";
import { PROJECT_URL } from "../../imports";
import { DebouncedInput } from "../Common/Filters";
import ReadModal from "../Common/ReadModal";
import { handleApiError } from "../Common/APIUtils";
import PageSizeDropdown from "../Common/PageSizeDropdown";
import { formattedDate } from "../Common/CommonUtils";
import { Menu, Transition } from "@headlessui/react";
import { Portal } from "react-portal";
import Pagination from "../Common/Pagination";
import NoDataFound from "../Common/NoDataFound";
import ResponseLoader from "../Common/ResponseLoader";

export default function Params() {
    let [isOpen, setIsOpen] = useState(false);
    let [isOpenRead, setIsOpenRead] = useState(false);
    let [rowData, setRowData] = useState([]);
    let [edit, setEdit] = useState(false);
    let [loader, setLoader] = useState(true);
    let [isOpenPopup, setIsOpenPopup] = useState(false);
    let [msg, setMsg] = useState(false);
    let [isSuccess, setIsSuccess] = useState(false);
    let [formState, setFormState] = useState([]);
    const [activeRowData, setActiveRowData] = useState(null);

    const [dropdownPosition, setDropdownPosition] = useState({ top: 0 });
    const [activeDropdown, setActiveDropdown] = useState(null);
    const buttonRefs = useRef({});
    const dropdownRef = useRef(null);

    // const calculatePosition = useCallback((id) => {
    //     const buttonRef = buttonRefs.current[id];
    //     if (buttonRef) {
    //         const rect = buttonRef.getBoundingClientRect();
    //         setDropdownPosition({
    //             top: rect.bottom + window.scrollY,
    //         });
    //         setActiveDropdown((prev) => (prev === id ? null : id));
    //     }
    // }, []);

    // STEP 2: Update calculatePosition to also store row data
    const calculatePosition = useCallback((id, rowData) => {
        const buttonRef = buttonRefs.current[id];
        if (buttonRef) {
            const rect = buttonRef.getBoundingClientRect();
            setDropdownPosition({
                top: rect.bottom + window.scrollY,
            });
            setActiveDropdown((prev) => (prev === id ? null : id));
            setActiveRowData(rowData); // Store the row data
        }
    }, []);

    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    //             setActiveDropdown(null);
    //         }
    //     };
    //     const handleKeyDown = (event) => {
    //         const keysToCloseDropdown = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp'];
    //         if (keysToCloseDropdown.includes(event.key)) {
    //             setActiveDropdown(null);
    //         }
    //     };
    //     const handleScroll = () => {
    //         setActiveDropdown(null);
    //     };
    //     if (activeDropdown !== null) {
    //         document.addEventListener("mousedown", handleClickOutside);
    //         document.addEventListener("keydown", handleKeyDown);
    //         window.addEventListener("scroll", handleScroll, true);
    //     }
    //     return () => {
    //         document.removeEventListener("mousedown", handleClickOutside);
    //         document.removeEventListener("keydown", handleKeyDown);
    //         window.removeEventListener("scroll", handleScroll, true);
    //     };
    // }, [activeDropdown]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setActiveDropdown(null);
                setActiveRowData(null); // Clear row data
            }
        };
        const handleKeyDown = (event) => {
            const keysToCloseDropdown = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp'];
            if (keysToCloseDropdown.includes(event.key)) {
                setActiveDropdown(null);
                setActiveRowData(null); // Clear row data
            }
        };
        const handleScroll = () => {
            setActiveDropdown(null);
            setActiveRowData(null); // Clear row data
        };
        if (activeDropdown !== null) {
            document.addEventListener("mousedown", handleClickOutside);
            document.addEventListener("keydown", handleKeyDown);
            window.addEventListener("scroll", handleScroll, true);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("scroll", handleScroll, true);
        };
    }, [activeDropdown]);

    function closePopup() {
        setIsOpenPopup(false);
    }

    function openPopup() {
        setIsOpenPopup(true);
    }

    // function closeModal() {
    //     setIsOpen(false);
    //     setRowData([]);
    // }
    function closeModal() {
        setIsOpen(false);
        setRowData({});
        setSelectedProcess('');  // ✅ Clear selected process
        setCategories([]);       // ✅ Clear categories
        setFormState([]);        // ✅ Clear form state
        setSelectedSubCategories([]);  // ✅ Clear subcategories
        setEdit(false);
    }

    const [categories, setCategories] = useState([]);
    const [selectedSubCategories, setSelectedSubCategories] = useState([]);
    const [showAllFields, setShowAllFields] = useState(false);
    const [processes, setProcesses] = useState([]);
    const [selectedProcess, setSelectedProcess] = useState("");

  // Handle selection change while ensuring only one subcategory per category
  const handleSelectionChange = (categoryId, subcategoryId) => {
        setSelectedSubCategories((prevSelected) => [
        ...prevSelected.filter((id) => 
            !categories.some(category => category.id === categoryId && category.subcategories.some(sub => sub.id === id))
        ), 
        subcategoryId
        ]);
        setShowAllFields(false);
    };

    function mergeFields(defFields, savedFields) {
        return defFields.map(def => {
            const saved = savedFields.find(f => f.key === def.key);

            if (!saved) {
                // field not present in saved fields → keep process definition as is
                return { 
                    ...def,
                    checked: false 
                };
            }

            return {
                ...def,
                defaultValue: saved.value,
                checked: true,
                nestedFields: def.nestedFields?.map(n => {
                    const savedNested = (saved.value || []).find(v => v.key === n.key);
                    return savedNested
                        ? { ...n, defaultValue: savedNested.value, checked: true }
                        : n;
                }) || []
            };
        });
    }
    const [data, setData] = useState([]);
    

    // const openModal = React.useCallback((e, option) => {
    //     if (option === "create") {
    //         // ✅ Handle create case
    //         setEdit(false);
    //         setRowData({});  // Set empty object instead of array
    //         setShowAllFields(false);
    //         setCategories([]);
    //         setFormState([]);
    //         setSelectedProcess("");
    //         setSelectedSubCategories([]);
    //         setIsOpen(true);
    //         return;
    //     }
        
    //     if (option === "edit" && e) {
    //         // ✅ Handle edit case
    //         setRowData(e);
    //         setEdit(true);
    //         setSelectedProcess(e.process_code);
            
    //         const selectedProcess = processes.find((item) => item.process_code === e.process_code);
    //         setCategories(selectedProcess ? selectedProcess.categories : []);
    //         setSelectedSubCategories(e.categories || []);
    //         setShowAllFields(e.categories ? false : true);
    //         setSelectedProcess(e.process_code);
            
    //         // Load fresh fields from process definition and merge with existing values
    //         if (selectedProcess && selectedProcess.fields) {
    //             const mergedFields = selectedProcess.fields.map(processField => {
    //                 const existingField = e.fields?.find(f => f.key === processField.key);
                    
    //                 if (existingField) {
    //                     return {
    //                         ...processField,
    //                         checked: existingField.checked !== undefined ? existingField.checked : processField.checked,
    //                         defaultValue: existingField.value !== undefined ? existingField.value : processField.defaultValue,
    //                         nestedFields: processField.nestedFields?.map(nestedField => {
    //                             const existingNested = existingField.value && Array.isArray(existingField.value) 
    //                                 ? existingField.value.find(nf => nf.key === nestedField.key)
    //                                 : null;
                                
    //                             return {
    //                                 ...nestedField,
    //                                 checked: existingNested ? true : (nestedField.checked || false),
    //                                 defaultValue: existingNested ? existingNested.value : nestedField.defaultValue
    //                             };
    //                         })
    //                     };
    //                 } else {
    //                     return processField;
    //                 }
    //             });
                
    //             setFormState(mergedFields);
    //         } else {
    //             setFormState(e.fields || []);
    //         }
            
    //     }
    //     setIsOpen(true);
    // }, [processes]);

    // const openModal = React.useCallback((e, option) => {
    //     console.log("=== openModal DEBUG ===");
    //     console.log("Option:", option);
    //     console.log("Row data e:", e);
    //     console.log("e.process_code:", e?.process_code);
    //     console.log("Available processes:", processes.map(p => ({ code: p.process_code, name: p.process_name })));
        
    //     if (option === "create") {
    //         setRowData({});
    //         setShowAllFields(false);
    //         setCategories([]);
    //         setFormState([]);
    //         setSelectedProcess("");
    //         setSelectedSubCategories([]);
    //         setEdit(false);
    //         setIsOpen(true);
    //         return;
    //     }
        
    // //     if (option === "edit" && e) {
    // //         setEdit(true);
    // //         setRowData(e);
            
    // //         console.log("Looking for process with code:", e.process_code);
    // //         const processes = response.data.data || [];
    // //         console.log("Processes data:", processes);
    // //         // const selectedProcess = processes.find((item) => {
    // //         //     console.log("Comparing:", item.process_code, "===", e.process_code, "?", item.process_code === e.process_code);
    // //         //     return item.process_code === e.process_code;
    // //         // });
            
    // //         // Find the process for the selected tab (ex: GETIDEAS or TRANSCRIPT)
    // //         const selectedProcess = processes.find(
    // //         (p) => p.process_code === currentProcessCode
    // //         );

    // //         console.log("Found selectedProcess:", selectedProcess ? selectedProcess.process_name : "NOT FOUND");
            
    // //         if (!selectedProcess) {
    // //             alert(`ERROR: Process not found for code: ${e.process_code}`);
    // //             return;
    // //         }

    // //         // Extract its fields array
    // //         const rows = selectedProcess.fields || [];

    // //         console.log("Final table rows:", rows);

    // //         // Update the table
    // //         setTableData(rows);
            
    // //         setSelectedProcess(e.process_code);
    // //         setCategories(selectedProcess.categories || []);
    // //         setSelectedSubCategories(e.categories || []);
    // //         setShowAllFields(e.categories ? false : true);
            
    // //         console.log("Setting formState with fields from:", selectedProcess.process_name);
    // //         console.log("Number of fields:", selectedProcess.fields?.length);
            
    // //         // Deep clone fresh fields
    // //         const freshFields = JSON.parse(JSON.stringify(selectedProcess.fields));
            
    // //         const populatedFields = freshFields.map(processField => {
    // //             const savedField = e.fields?.find(f => f.key === processField.key);
                
    // //             if (savedField) {
    // //                 const populatedField = {
    // //                     ...processField,
    // //                     checked: true,
    // //                     defaultValue: savedField.value || processField.defaultValue
    // //                 };
                    
    // //                 if (processField.nestedFields && processField.nestedFields.length > 0) {
    // //                     populatedField.nestedFields = processField.nestedFields.map(nestedField => {
    // //                         if (Array.isArray(savedField.value)) {
    // //                             const savedNested = savedField.value.find(nf => nf.key === nestedField.key);
    // //                             if (savedNested) {
    // //                                 return {
    // //                                     ...nestedField,
    // //                                     checked: true,
    // //                                     defaultValue: savedNested.value || nestedField.defaultValue
    // //                                 };
    // //                             }
    // //                         }
    // //                         return nestedField;
    // //                     });
    // //                 }
                    
    // //                 return populatedField;
    // //             } else {
    // //                 return {
    // //                     ...processField,
    // //                     checked: false
    // //                 };
    // //             }
    // //         });
            
    // //         console.log("Final formState:", populatedFields.map(f => f.key));
    // //         setFormState(populatedFields);
    // //         setIsOpen(true);
    // //     }
    // // }, [processes]);
    
    // if (option === "edit" && e) {
    //     setEdit(true);
    //     setRowData(e);

    //     console.log("Entering EDIT mode for process:", e.process_code);

    //     // Find the process definition (from API)
    //     const selectedProcess = processes.find(
    //         (p) => p.process_code === e.process_code
    //     );

    //     console.log("Selected Process:", selectedProcess);

    //     if (!selectedProcess) {
    //         alert(`ERROR: Process not found for code: ${e.process_code}`);
    //         return;
    //     }

    //     // UI states
    //     setSelectedProcess(e.process_code);
    //     setCategories(selectedProcess.categories || []);
    //     setSelectedSubCategories(e.categories || []);
    //     setShowAllFields(e.categories ? false : true);

    //     console.log("Setting formState based on saved values...");

    //     // Clone fresh fields from process definition
    //     const freshFields = JSON.parse(JSON.stringify(selectedProcess.fields));

    //     // Map with saved values
    //     const populatedFields = freshFields.map((processField) => {
    //         const savedField = e.fields?.find((f) => f.key === processField.key);

    //         if (savedField) {
    //             const populatedField = {
    //                 ...processField,
    //                 checked: true,
    //                 defaultValue: savedField.value || processField.defaultValue,
    //             };

    //             // Nested fields
    //             if (
    //                 processField.nestedFields &&
    //                 processField.nestedFields.length > 0
    //             ) {
    //                 populatedField.nestedFields = processField.nestedFields.map(
    //                     (nestedField) => {
    //                         if (Array.isArray(savedField.value)) {
    //                             const savedNested = savedField.value.find(
    //                                 (nf) => nf.key === nestedField.key
    //                             );
    //                             if (savedNested) {
    //                                 return {
    //                                     ...nestedField,
    //                                     checked: true,
    //                                     defaultValue:
    //                                         savedNested.value ||
    //                                         nestedField.defaultValue,
    //                                 };
    //                             }
    //                         }
    //                         return nestedField;
    //                     }
    //                 );
    //             }

    //             return populatedField;
    //         } else {
    //             return { ...processField, checked: false };
    //         }
    //     });

    //     console.log(
    //         "Final formState (fields):",
    //         populatedFields.map((f) => f.key)
    //     );

    //     setFormState(populatedFields);
    //     setIsOpen(true);
    // }
    // }, [processes]); // Add this line to close the useCallback

    const openModal = React.useCallback((e, option) => {
        console.log("=== openModal DEBUG ===");
        console.log("Option:", option);
        console.log("Row data e:", e);
        console.log("e.process_code:", e?.process_code);
        console.log("Available processes:", processes.map(p => ({ code: p.process_code, name: p.process_name })));
        
        if (option === "create") {
            setRowData({});
            setShowAllFields(false);
            setCategories([]);
            setFormState([]);
            setSelectedProcess("");
            setSelectedSubCategories([]);
            setEdit(false);
            setIsOpen(true);
            return;
        }
        
        if (option === "edit" && e) {
            setEdit(true);
            setRowData(e);

            console.log("Entering EDIT mode for process:", e.process_code);

            // Find the process definition (from API)
            const selectedProcess = processes.find(
                (p) => p.process_code === e.process_code
            );

            console.log("Selected Process:", selectedProcess);

            if (!selectedProcess) {
                alert(`ERROR: Process not found for code: ${e.process_code}`);
                return;
            }

            // UI states
            setSelectedProcess(e.process_code);
            setCategories(selectedProcess.categories || []);
            setSelectedSubCategories(e.categories || []);
            setShowAllFields(e.categories ? false : true);

            console.log("Setting formState based on saved values...");

            // Clone fresh fields from process definition
            const freshFields = JSON.parse(JSON.stringify(selectedProcess.fields));

            // Map with saved values
            const populatedFields = freshFields.map((processField) => {
                const savedField = e.fields?.find((f) => f.key === processField.key);

                if (savedField) {
                    const populatedField = {
                        ...processField,
                        checked: true,
                        defaultValue: savedField.value || processField.defaultValue,
                    };

                    // Nested fields
                    if (
                        processField.nestedFields &&
                        processField.nestedFields.length > 0
                    ) {
                        populatedField.nestedFields = processField.nestedFields.map(
                            (nestedField) => {
                                if (Array.isArray(savedField.value)) {
                                    const savedNested = savedField.value.find(
                                        (nf) => nf.key === nestedField.key
                                    );
                                    if (savedNested) {
                                        return {
                                            ...nestedField,
                                            checked: true,
                                            defaultValue:
                                                savedNested.value ||
                                                nestedField.defaultValue,
                                        };
                                    }
                                }
                                return nestedField;
                            }
                        );
                    }

                    return populatedField;
                } else {
                    return { ...processField, checked: false };
                }
            });

            console.log(
                "Final formState (fields):",
                populatedFields.map((f) => f.key)
            );

            setFormState(populatedFields);
            setIsOpen(true);
        }
    }, [processes]);

    function closeReadModal() {
        setIsOpenRead(false);
    }

    // function openReadModal(e) {
    //     setRowData(e || {});
    //     setModalTitle(`Parameters Response of ${e?.param_code || 'Unknown'}`);
    //     setIsOpenRead(true);
    // }
    // function openReadModal(e) {
    //     console.log("🔍 Opening Read Modal for:", e.param_code);
    //     console.log("🔍 Row data e.params:", JSON.stringify(e.params, null, 2));
    //     console.log("🔍 Row data e.fields:", JSON.stringify(e.fields, null, 2));
    //     console.log("🔍 Full row data:", JSON.stringify(e, null, 2));
    //     // Find the process definition to get all fields
    //     const selectedProcess = processes.find(p => p.process_code === e.process_code);
        
    //     // Build complete params object with all fields
    //     const completeParams = {};
        
    //     if (selectedProcess && selectedProcess.fields) {
    //         selectedProcess.fields.forEach(field => {
    //             const savedField = e.fields?.find(f => f.key === field.key);
                
    //             if (savedField) {
    //                 // Use saved value
    //                 completeParams[field.key] = savedField.value;
    //             } else {
    //                 // Use default value from process definition
    //                 completeParams[field.key] = field.defaultValue;
    //             }
    //         });
    //     }

    //     // ✅ Add transcription-specific fields directly from saved data
    //     if (e.process_code === 'TRANSCRIPT' || e.process_code === 'Transcription') {
    //         const transcriptKeys = ['keep_original_lang', 'enable_pre_process', 'pii_masking', 'pii_entities_list'];
    //         transcriptKeys.forEach(key => {
    //             const savedField = e.fields?.find(f => f.key === key);
    //             if (savedField) {
    //                 completeParams[key] = savedField.value;
    //             }
    //         });
    //     }
        
    //     setRowData({ ...e, params: completeParams });
    //     setModalTitle(`Parameters Response of ${e?.param_code || 'Unknown'}`);
    //     setIsOpenRead(true);
    // }

    function openReadModal(e) {
        console.log("🔍 Opening Read Modal for:", e.param_code);
        console.log("🔍 Row data e.params:", JSON.stringify(e.params, null, 2));
        console.log("🔍 Row data e.fields:", JSON.stringify(e.fields, null, 2));
        console.log("🔍 Full row data:", JSON.stringify(e, null, 2));
        
        // ✅ Directly use the params object from the row data
        // This is the actual params that will be sent to the API
        setRowData(e);
        setModalTitle(`Parameters Response of ${e?.param_code || 'Unknown'}`);
        setIsOpenRead(true);
    }
    

    const ReloadData = async (reload=false) => {
        if(reload){setLoader(true)};
        axios
            .get(`${PROJECT_URL}/projects/params/${sessionStorage.getItem(
                        "projectCode"
                    )}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "access_token"
                    )}`,
                },
            })
            .then((response) => {
                console.log("🔍 API Response:", response.data.data);
                console.log("🔍 First item param_code:", response.data.data[0]?.param_code);
                console.log("🔍 First item full:", response.data.data[0]);
                setData(response.data.data);
            })
            .catch((error) => {
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            }).finally(()=>{
                setTimeout(() => {
                    setLoader(false);
                },200)
            });
    };

    // const [files, setFiles] = useState([]);

    // const acceptedFileTypes = {
    //     "application/json": [".json"],
    // };

    // const maxFileSize = {
    //     ".json": 30 * 1024 * 1024, // 30MB
    // };

    // function getFileExtension(filename) {
    //     return "." + filename.split(".").pop().toLowerCase();
    // }

    // function handleFileChange(acceptedFiles) {
    //     const validatedFiles = acceptedFiles.filter((file) => {
    //         const fileExtension = getFileExtension(file.name);
    //         const fileSize = file.size;

    //         if (!acceptedFileTypes[file.type]?.includes(fileExtension)) {
    //             setMsg("Invalid file type. Only json files are allowed.");
    //             setIsSuccess(false);
    //             openPopup();
    //             return false;
    //         }

    //         if (fileSize > maxFileSize[fileExtension]) {
    //             setMsg(
    //                 `File size exceeds the limit for ${fileExtension} files.`
    //             );
    //             setIsSuccess(false);
    //             openPopup();
    //             return false;
    //         }

    //         return true;
    //     });

    //     setFiles(validatedFiles);
    // }

    // const { getRootProps, getInputProps } = useDropzone({
    //     accept: acceptedFileTypes,
    //     maxSize: Math.max(...Object.values(maxFileSize)),
    //     onDrop: handleFileChange,
    //     multiple: false,
    // });

    // const emptyFilesState = () => {
    //     setFiles([]);
    // };

    const responseStateHandler = (responseMessage, responseState) => {
        // emptyFilesState();
        setMsg(responseMessage);
        setIsSuccess(responseState);
        openPopup();
    };

    const deactivateOtherPostProcessingParams = async () => {
        try {
            // Get all params
            const response = await axios.get(
                `${PROJECT_URL}/projects/params/${sessionStorage.getItem("projectCode")}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                }
            );
            
            // Find all active POST_PROCESSING params
            const activePostProcessParams = response.data.data.filter(
                param => (param.process_code === 'POST_PROCESSING' || param.process_code === 'PostProcessing') && param.status === true
            );
            
            // Deactivate each one
            for (const param of activePostProcessParams) {
                await axios.patch(
                    `${PROJECT_URL}/projects/params/status/${sessionStorage.getItem("projectCode")}/${param._id || param.id}`,
                    { status: false },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );
            }
        } catch (error) {
            console.error("Error deactivating other POST_PROCESSING params:", error);
        }
    };

    const deactivateOtherDiarizationParams = async () => {
        try {
            const response = await axios.get(
                `${PROJECT_URL}/projects/params/${sessionStorage.getItem("projectCode")}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                }
            );
            
            const activeDiarizationParams = response.data.data.filter(
                param => (param.process_code === 'DIARIZATION' || param.process_code === 'Diarization') && param.status === true
            );
            
            for (const param of activeDiarizationParams) {
                await axios.patch(
                    `${PROJECT_URL}/projects/params/status/${sessionStorage.getItem("projectCode")}/${param._id || param.id}`,
                    { status: false },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );
            }
        } catch (error) {
            console.error("Error deactivating other DIARIZATION params:", error);
        }
    };

    // function convertBytesToMB(bytes) {
    //     if (bytes === 0) {
    //         return "0 KB";
    //     } else if (bytes < 1024) {
    //         return `${bytes} Bytes`;
    //     } else if (bytes >= 1024 && bytes < 1024 * 1024) {
    //         const kilobytes = bytes / 1024;
    //         return kilobytes.toFixed(2) + " KB";
    //     } else {
    //         const megabytes = bytes / (1024 * 1024);
    //         return megabytes.toFixed(2) + " MB";
    //     }
    // }

//     const handleCreateState = async () => {
//         setIsOpen(false);
//         const process_code = rowData.process_code;

//         // let createdParams = formState
//         // .filter((field) => field.checked) // Only include checked fields
//         // .map((field) => {
//         //     // Check if there are selected nested fields
//         //     const nestedValues = field.nestedFields?.filter((nestedField) => nestedField.checked)
//         //         .map(({ key, defaultValue, type }) => ({
//         //         key,
//         //         value: defaultValue,
//         //         type
//         //         }));
            
//         //     return {
//         //         key: field.key,
//         //         value: nestedValues && nestedValues.length > 0 ? nestedValues : field.defaultValue,
//         //         type: field.type,
//         //         nested: nestedValues && nestedValues.length > 0 ? true : false
//         //     };
//         // });
//         let createdParams = formState
//             .filter((field) => field.checked) // Only include checked fields
//             .map((field) => {
//                 let finalValue = field.defaultValue; // Default value fallback
//                 let isNested = false; // Track if nested exists
                
//                 // Apply useCategory logic if present
//                 if (field.useCategory && field.subcategoryConfig) {
//                     const matchedKey = selectedSubCategories.find(sub => field.subcategoryConfig[sub]); // Find a matching key
                    
//                     if (matchedKey) {
//                         const matchedConfig = field.subcategoryConfig[matchedKey]; // Get the matched config
//                         if (matchedConfig.action === "neglect") {
//                             return null; // Skip this field
//                         } 
//                         if (matchedConfig.action === "default") {
//                             finalValue = matchedConfig.value; // Use actual value
//                         } 
//                         if (matchedConfig.action === "editable") {
//                             finalValue = field.defaultValue; // Use defaultValue
//                         }
//                     }
//                 } else {
//                     finalValue = field.defaultValue; // Normal case
//                 }

//                 // Check if there are selected nested fields
//                 const nestedValues = field.nestedFields?.filter(nestedField => nestedField.checked)
//                     .map(({ key, defaultValue, type, useCategory, subcategoryConfig }) => {
//                         let nestedFinalValue = defaultValue;

//                         if (useCategory && subcategoryConfig) {
//                             const nestedMatchedKey = selectedSubCategories.find(sub => subcategoryConfig[sub]);
                            
//                             if (nestedMatchedKey) {
//                                 const nestedMatchedConfig = subcategoryConfig[nestedMatchedKey];
//                                 if (nestedMatchedConfig.action === "neglect") {
//                                     return null; // Remove nested field
//                                 } 
//                                 if (nestedMatchedConfig.action === "default") {
//                                     nestedFinalValue = nestedMatchedConfig.value; // Use actual value
//                                 } 
//                                 if (nestedMatchedConfig.action === "editable") {
//                                     nestedFinalValue = defaultValue; // Use defaultValue
//                                 }
//                             }
//                         } else {
//                             nestedFinalValue = defaultValue;
//                         }

//                         return nestedFinalValue !== null ? { key, value: nestedFinalValue, type } : null;
//                     })
//                     .filter(nestedField => nestedField !== null); // Remove nulls (removed fields)

//                 // Determine if this field should be treated as nested
//                 if (nestedValues && nestedValues.length > 0) {
//                     isNested = true;
//                 }

//                 return {
//                     key: field.key,
//                     value: isNested ? nestedValues : finalValue,
//                     type: field.type,
//                     nested: isNested
//                 };
//             })
//             .filter(field => field !== null); // Remove null fields (removed by category logic)
//         // console.log(createdParams);
//         if (!selectedProcess) {
//             responseStateHandler("Please select process", false);
//             return;
//         }

//         if (createdParams.length === 0) {
//             responseStateHandler("Please select at least one field", false);
//             return;
// }
//         try {
//             await axios
//                 .post(
//                     `${PROJECT_URL}/projects/params/${sessionStorage.getItem(
//                     // `${PROJECT_URL}/params/${sessionStorage.getItem(
//                         "projectCode"
//                     )}`,
//                     {
//                         // "process":selectedProcess,
//                         "process":selectedProcess,
//                         "fields":createdParams,
//                         "categories":selectedSubCategories},
//                     {
//                         headers: {
//                             Authorization: `Bearer ${localStorage.getItem(
//                                 "access_token"
//                             )}`,
//                         },
//                         params: {
//                             set_active: selectedProcess === 'TRANSCRIPT' || selectedProcess === 'GETIDEAS'  // ✅ Add GETIDEAS
//                         }
//                     }
//                 )
//                 .then((response) => {
//                     responseStateHandler(response.data.message, true);
//                     ReloadData();
//                 });
//         } catch (error) {
//             const errorMessage = handleApiError(error);
//             responseStateHandler(errorMessage, false);
//         }
//     };

    // const handleCreateState = async () => {
    //     setIsOpen(false);
    //     const process_code = rowData.process_code;

    //     // ✅ For TRANSCRIPT process, always include transcription config fields
    //     const transcriptConfigKeys = ['keep_original_lang', 'enable_pre_process', 'pii_masking', 'pii_entities_list'];
    //     const isTranscriptProcess = selectedProcess === 'TRANSCRIPT' || selectedProcess === 'Transcription';

    //     let createdParams = formState
    //         .filter((field) => {
    //             // Always include checked fields
    //             if (field.checked) return true;
                
    //             // ✅ For TRANSCRIPT, also include transcription config fields even if unchecked
    //             if (isTranscriptProcess && transcriptConfigKeys.includes(field.key)) {
    //                 return true;
    //             }
                
    //             return false;
    //         })
    //         .map((field) => {
    //             let finalValue = field.defaultValue; // Default value fallback
    //             let isNested = false; // Track if nested exists
                
    //             // Apply useCategory logic if present
    //             if (field.useCategory && field.subcategoryConfig) {
    //                 const matchedKey = selectedSubCategories.find(sub => field.subcategoryConfig[sub]); // Find a matching key
                    
    //                 if (matchedKey) {
    //                     const matchedConfig = field.subcategoryConfig[matchedKey]; // Get the matched config
    //                     if (matchedConfig.action === "neglect") {
    //                         return null; // Skip this field
    //                     } 
    //                     if (matchedConfig.action === "default") {
    //                         finalValue = matchedConfig.value; // Use actual value
    //                     } 
    //                     if (matchedConfig.action === "editable") {
    //                         finalValue = field.defaultValue; // Use defaultValue
    //                     }
    //                 }
    //             } else {
    //                 finalValue = field.defaultValue; // Normal case
    //             }

    //             // Check if there are selected nested fields
    //             const nestedValues = field.nestedFields?.filter(nestedField => nestedField.checked)
    //                 .map(({ key, defaultValue, type, useCategory, subcategoryConfig }) => {
    //                     let nestedFinalValue = defaultValue;

    //                     if (useCategory && subcategoryConfig) {
    //                         const nestedMatchedKey = selectedSubCategories.find(sub => subcategoryConfig[sub]);
                            
    //                         if (nestedMatchedKey) {
    //                             const nestedMatchedConfig = subcategoryConfig[nestedMatchedKey];
    //                             if (nestedMatchedConfig.action === "neglect") {
    //                                 return null; // Remove nested field
    //                             } 
    //                             if (nestedMatchedConfig.action === "default") {
    //                                 nestedFinalValue = nestedMatchedConfig.value; // Use actual value
    //                             } 
    //                             if (nestedMatchedConfig.action === "editable") {
    //                                 nestedFinalValue = defaultValue; // Use defaultValue
    //                             }
    //                         }
    //                     } else {
    //                         nestedFinalValue = defaultValue;
    //                     }

    //                     return nestedFinalValue !== null ? { key, value: nestedFinalValue, type } : null;
    //                 })
    //                 .filter(nestedField => nestedField !== null); // Remove nulls (removed fields)

    //             // Determine if this field should be treated as nested
    //             if (nestedValues && nestedValues.length > 0) {
    //                 isNested = true;
    //             }

    //             return {
    //                 key: field.key,
    //                 value: isNested ? nestedValues : finalValue,
    //                 type: field.type,
    //                 nested: isNested
    //             };
    //         })
    //         .filter(field => field !== null); // Remove null fields (removed by category logic)
            
    //     if (!selectedProcess) {
    //         responseStateHandler("Please select process", false);
    //         return;
    //     }

    //     if (createdParams.length === 0) {
    //         responseStateHandler("Please select at least one field", false);
    //         return;
    //     }
        
    //     try {
    //         await axios
    //             .post(
    //                 `${PROJECT_URL}/projects/params/${sessionStorage.getItem(
    //                     "projectCode"
    //                 )}`,
    //                 {
    //                     "process":selectedProcess,
    //                     "fields":createdParams,
    //                     "categories":selectedSubCategories
    //                 },
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem(
    //                             "access_token"
    //                         )}`,
    //                     },
    //                     params: {
    //                         set_active: selectedProcess === 'TRANSCRIPT' || selectedProcess === 'GETIDEAS'
    //                     }
    //                 }
    //             )
    //             .then((response) => {
    //                 responseStateHandler(response.data.message, true);
    //                 ReloadData();
    //             });
    //     } catch (error) {
    //         const errorMessage = handleApiError(error);
    //         responseStateHandler(errorMessage, false);
    //     }
    // };

    // const handleEditState = async () => {
    //     setIsOpen(false);
    //     // let updatedParams = formState
    //     // .filter((field) => field.checked) // Only include checked fields
    //     // .map((field) => {
    //     //     // Check if there are selected nested fields
    //     //     const nestedValues = field.nestedFields?.filter((nestedField) => nestedField.checked)
    //     //         .map(({ key, defaultValue, type }) => ({
    //     //         key,
    //     //         value: defaultValue,
    //     //         type
    //     //         }));
            
    //     //     return {
    //     //         key: field.key,
    //     //         value: nestedValues && nestedValues.length > 0 ? nestedValues : field.defaultValue,
    //     //         type: field.type,
    //     //         nested: nestedValues && nestedValues.length > 0 ? true : false
    //     //     };
    //     // });
    //     let updatedParams = formState
    //     .filter((field) => field.checked) // Only include checked fields
    //     .map((field) => {
    //         let finalValue = field.defaultValue; // Default value fallback
    //         let isNested = false; // Track if nested exists
            
    //         // Apply useCategory logic if present
    //         if (field.useCategory && field.subcategoryConfig) {
    //             const matchedKey = selectedSubCategories.find(sub => field.subcategoryConfig[sub]); // Find a matching key
                
    //             if (matchedKey) {
    //                 const matchedConfig = field.subcategoryConfig[matchedKey]; // Get the matched config
    //                 if (matchedConfig.action === "neglect") {
    //                     return null; // Skip this field
    //                 } 
    //                 if (matchedConfig.action === "default") {
    //                     finalValue = matchedConfig.value; // Use actual value
    //                 } 
    //                 if (matchedConfig.action === "editable") {
    //                     finalValue = field.defaultValue; // Use defaultValue
    //                 }
    //             }
    //         } else {
    //             finalValue = field.defaultValue; // Normal case
    //         }

    //         // Check if there are selected nested fields
    //         const nestedValues = field.nestedFields?.filter(nestedField => nestedField.checked)
    //             .map(({ key, defaultValue, type, useCategory, subcategoryConfig }) => {
    //                 let nestedFinalValue = defaultValue;

    //                 if (useCategory && subcategoryConfig) {
    //                     const nestedMatchedKey = selectedSubCategories.find(sub => subcategoryConfig[sub]);
                        
    //                     if (nestedMatchedKey) {
    //                         const nestedMatchedConfig = subcategoryConfig[nestedMatchedKey];
    //                         if (nestedMatchedConfig.action === "neglect") {
    //                             return null; // Remove nested field
    //                         } 
    //                         if (nestedMatchedConfig.action === "default") {
    //                             nestedFinalValue = nestedMatchedConfig.value; // Use actual value
    //                         } 
    //                         if (nestedMatchedConfig.action === "editable") {
    //                             nestedFinalValue = defaultValue; // Use defaultValue
    //                         }
    //                     }
    //                 } else {
    //                     nestedFinalValue = defaultValue;
    //                 }

    //                 return nestedFinalValue !== null ? { key, value: nestedFinalValue, type } : null;
    //             })
    //             .filter(nestedField => nestedField !== null); // Remove nulls (removed fields)

    //         // Determine if this field should be treated as nested
    //         if (nestedValues && nestedValues.length > 0) {
    //             isNested = true;
    //         }

    //         return {
    //             key: field.key,
    //             // value: isNested ? nestedValues : finalValue,
    //             value: isNested
    //                 ? Object.fromEntries(
    //                     nestedValues.map(n => [n.key, n.value])
    //                 )
    //                 : finalValue,
    //             type: field.type,
    //             nested: isNested
    //         };
    //     })
    //     .filter(field => field !== null); // Remove null fields (removed by category logic)
    //     try {
    //         await axios
    //             .patch(
    //                 `${PROJECT_URL}/projects/params/${sessionStorage.getItem(
    //                 // `${PROJECT_URL}/params/${sessionStorage.getItem(
    //                     "projectCode"
    //                 )}/${rowData._id || rowData.id}`,
    //                 {'fields':updatedParams, 'categories':selectedSubCategories}, {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem(
    //                         "access_token"
    //                     )}`,
    //                 },
    //             })
    //             .then((response) => {
    //                 responseStateHandler(response.data.message, true);
    //                 ReloadData();
    //             });
    //     } catch (error) {
    //         const errorMessage = handleApiError(error);
    //         responseStateHandler(errorMessage, false);
    //     }
    // };

    const handleCreateState = async () => {
        setIsOpen(false);
        const process_code = rowData.process_code;

        // ✅ For TRANSCRIPT process, always include transcription config fields
        const transcriptConfigKeys = ['keep_original_lang', 'enable_pre_process', 'pii_masking', 'pii_entities_list'];
        const isTranscriptProcess = selectedProcess === 'TRANSCRIPT' || selectedProcess === 'Transcription';

        let createdParams = formState
            .filter((field) => {
                // Always include checked fields
                if (field.checked) return true;
                
                // ✅ For TRANSCRIPT, also include transcription config fields even if unchecked
                if (isTranscriptProcess && transcriptConfigKeys.includes(field.key)) {
                    return true;
                }
                // ✅ For GET_IDEAS, include all toggle fields even if unchecked
                if ((selectedProcess === 'GETIDEAS' || selectedProcess === 'GET_IDEAS') && 
                    ['get_topics', 'get_sentiment', 'get_aliases', 'get_ner', 'get_feature_list', 
                    'industry', 'company_brand_names', 'feature_lst', 'aliases'].includes(field.key)) {
                    return true;
                }
                // ✅ For DIARIZATION, include all fields even if unchecked
                if ((selectedProcess === 'DIARIZATION' || selectedProcess === 'Diarization') && 
                    ['enable_fixes', 'process_as_wav', 'pii_masking', 'enable_pre_process', 'keep_original_lang'].includes(field.key)) {
                    return true;
                }
                return false;
            })
            .map((field) => {
                let finalValue = field.defaultValue; // Default value fallback
                let isNested = false; // Track if nested exists
                
                // Apply useCategory logic if present
                if (field.useCategory && field.subcategoryConfig) {
                    const matchedKey = selectedSubCategories.find(sub => field.subcategoryConfig[sub]); // Find a matching key
                    
                    if (matchedKey) {
                        const matchedConfig = field.subcategoryConfig[matchedKey]; // Get the matched config
                        if (matchedConfig.action === "neglect") {
                            return null; // Skip this field
                        } 
                        if (matchedConfig.action === "default") {
                            finalValue = matchedConfig.value; // Use actual value
                        } 
                        if (matchedConfig.action === "editable") {
                            finalValue = field.defaultValue; // Use defaultValue
                        }
                    }
                } else {
                    finalValue = field.defaultValue; // Normal case
                }

                // Check if there are selected nested fields
                const nestedValues = field.nestedFields?.filter(nestedField => nestedField.checked)
                    .map(({ key, defaultValue, type, useCategory, subcategoryConfig }) => {
                        let nestedFinalValue = defaultValue;

                        if (useCategory && subcategoryConfig) {
                            const nestedMatchedKey = selectedSubCategories.find(sub => subcategoryConfig[sub]);
                            
                            if (nestedMatchedKey) {
                                const nestedMatchedConfig = subcategoryConfig[nestedMatchedKey];
                                if (nestedMatchedConfig.action === "neglect") {
                                    return null; // Remove nested field
                                } 
                                if (nestedMatchedConfig.action === "default") {
                                    nestedFinalValue = nestedMatchedConfig.value; // Use actual value
                                } 
                                if (nestedMatchedConfig.action === "editable") {
                                    nestedFinalValue = defaultValue; // Use defaultValue
                                }
                            }
                        } else {
                            nestedFinalValue = defaultValue;
                        }

                        return nestedFinalValue !== null ? { key, value: nestedFinalValue, type } : null;
                    })
                    .filter(nestedField => nestedField !== null); // Remove nulls (removed fields)

                // Determine if this field should be treated as nested
                if (nestedValues && nestedValues.length > 0) {
                    isNested = true;
                }

                return {
                    key: field.key,
                    value: isNested ? nestedValues : finalValue,
                    type: field.type,
                    nested: isNested
                };
            })
            .filter(field => field !== null) // Remove null fields (removed by category logic)
            .map(field => {
                // ✅ Convert pii_entities_list from string to array
                if (field.key === 'pii_entities_list') {
                    if (typeof field.value === 'string') {
                        field.value = field.value.trim() === '' 
                            ? [] 
                            : field.value.split(',').map(s => s.trim()).filter(s => s);
                    }
                }
                return field;
            });
            
        if (!selectedProcess) {
            responseStateHandler("Please select process", false);
            return;
        }

        if (createdParams.length === 0) {
            responseStateHandler("Please select at least one field", false);
            return;
        }
        
        try {
            // Deactivate other POST_PROCESSING params if this is POST_PROCESSING
            if (selectedProcess === 'POST_PROCESSING' || selectedProcess === 'PostProcessing') {
                await deactivateOtherPostProcessingParams();
            }
            if (selectedProcess === 'DIARIZATION' || selectedProcess === 'Diarization') {
                await deactivateOtherDiarizationParams();
            }
            {/* REFINED ANSWERS Configuration Fields */}
            {(selectedProcess === 'REFINED' || selectedProcess === 'Refined Answers') && (
                <div className="border-t pt-4 mt-4">
                    <h3 className="text-sm font-medium text-gray-700 mb-3">Refined Answers Settings</h3>
                    
                    <div className="p-3 bg-blue-50 rounded-lg mb-4">
                        <p className="text-sm text-blue-900">
                            <strong>Note:</strong> Select your input type above. Company Information fields are only available for Text File and Paragraph input types.
                        </p>
                    </div>
                </div>
            )}
            {/* END REFINED ANSWERS FIELDS */}
            await axios
                .post(
                    `${PROJECT_URL}/projects/params/${sessionStorage.getItem(
                        "projectCode"
                    )}`,
                    {
                        "process":selectedProcess,
                        "fields":createdParams,
                        "categories":selectedSubCategories
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                "access_token"
                            )}`,
                        },
                        params: {
                            set_active: 
                            selectedProcess === 'TRANSCRIPT' || 
                            selectedProcess === 'GETIDEAS' || 
                            selectedProcess === 'POST_PROCESSING' ||
                            selectedProcess === 'DIARIZATION' ||
                            selectedProcess === 'REFINED'
                        }
                    }
                )
                .then((response) => {
                    responseStateHandler(response.data.message, true);
                    ReloadData();
                });
        } catch (error) {
            const errorMessage = handleApiError(error);
            responseStateHandler(errorMessage, false);
        }
    };

    const handleEditState = async () => {
        setIsOpen(false);
        
        // ✅ For TRANSCRIPT process, always include transcription config fields
        const transcriptConfigKeys = ['keep_original_lang', 'enable_pre_process', 'pii_masking', 'pii_entities_list'];
        const isTranscriptProcess = selectedProcess === 'TRANSCRIPT' || selectedProcess === 'Transcription';
        
        let updatedParams = formState
        .filter((field) => {
            // Always include checked fields
            if (field.checked) return true;
            
            // ✅ For TRANSCRIPT, also include transcription config fields even if unchecked
            if (isTranscriptProcess && transcriptConfigKeys.includes(field.key)) {
                return true;
            }

             // ✅ For GET_IDEAS, include all fields even if unchecked
            if ((selectedProcess === 'GETIDEAS' || selectedProcess === 'GET_IDEAS') && 
                ['get_topics', 'get_sentiment', 'get_aliases', 'get_ner', 'get_feature_list', 
                'industry', 'company_brand_names', 'feature_lst', 'aliases'].includes(field.key)) {
                return true;
            }

            // ✅ For DIARIZATION, include all fields even if unchecked
            if ((selectedProcess === 'DIARIZATION' || selectedProcess === 'Diarization') && 
                ['enable_fixes', 'process_as_wav', 'pii_masking', 'enable_pre_process', 'keep_original_lang'].includes(field.key)) {
                return true;
            }
                
            return false;
        })
        .map((field) => {
            let finalValue = field.defaultValue; // Default value fallback
            let isNested = false; // Track if nested exists
            
            // Apply useCategory logic if present
            if (field.useCategory && field.subcategoryConfig) {
                const matchedKey = selectedSubCategories.find(sub => field.subcategoryConfig[sub]); // Find a matching key
                
                if (matchedKey) {
                    const matchedConfig = field.subcategoryConfig[matchedKey]; // Get the matched config
                    if (matchedConfig.action === "neglect") {
                        return null; // Skip this field
                    } 
                    if (matchedConfig.action === "default") {
                        finalValue = matchedConfig.value; // Use actual value
                    } 
                    if (matchedConfig.action === "editable") {
                        finalValue = field.defaultValue; // Use defaultValue
                    }
                }
            } else {
                finalValue = field.defaultValue; // Normal case
            }

            // Check if there are selected nested fields
            const nestedValues = field.nestedFields?.filter(nestedField => nestedField.checked)
                .map(({ key, defaultValue, type, useCategory, subcategoryConfig }) => {
                    let nestedFinalValue = defaultValue;

                    if (useCategory && subcategoryConfig) {
                        const nestedMatchedKey = selectedSubCategories.find(sub => subcategoryConfig[sub]);
                        
                        if (nestedMatchedKey) {
                            const nestedMatchedConfig = subcategoryConfig[nestedMatchedKey];
                            if (nestedMatchedConfig.action === "neglect") {
                                return null; // Remove nested field
                            } 
                            if (nestedMatchedConfig.action === "default") {
                                nestedFinalValue = nestedMatchedConfig.value; // Use actual value
                            } 
                            if (nestedMatchedConfig.action === "editable") {
                                nestedFinalValue = defaultValue; // Use defaultValue
                            }
                        }
                    } else {
                        nestedFinalValue = defaultValue;
                    }

                    return nestedFinalValue !== null ? { key, value: nestedFinalValue, type } : null;
                })
                .filter(nestedField => nestedField !== null); // Remove nulls (removed fields)

            // Determine if this field should be treated as nested
            if (nestedValues && nestedValues.length > 0) {
                isNested = true;
            }

            return {
                key: field.key,
                value: isNested
                    ? Object.fromEntries(
                        nestedValues.map(n => [n.key, n.value])
                    )
                    : finalValue,
                type: field.type,
                nested: isNested
            };
        })
        .filter(field => field !== null) // Remove null fields (removed by category logic)
        .map(field => {
            // ✅ Convert pii_entities_list from string to array
            if (field.key === 'pii_entities_list') {
                if (typeof field.value === 'string') {
                    field.value = field.value.trim() === '' 
                        ? [] 
                        : field.value.split(',').map(s => s.trim()).filter(s => s);
                }
            }
            return field;
        });
        
        try {
            await axios
                .patch(
                    `${PROJECT_URL}/projects/params/${sessionStorage.getItem(
                        "projectCode"
                    )}/${rowData._id || rowData.id}`,
                    {'fields':updatedParams, 'categories':selectedSubCategories}, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            "access_token"
                        )}`,
                    },
                })
                .then((response) => {
                    responseStateHandler(response.data.message, true);
                    ReloadData();
                });
        } catch (error) {
            const errorMessage = handleApiError(error);
            responseStateHandler(errorMessage, false);
        }
    };

    let [isOpenStatusModal, setIsOpenStatusModal] = useState(false);
    let [modalTitle, setModalTitle] = useState("");

    function closeStatusModal() {
        setIsOpenStatusModal(false);
    }

    function openStatusModal(e) {
        setRowData(e);
        setModalTitle(`Update Project Status - ${e.param_code}`);
        setIsOpenStatusModal(true);
    }

    const handleStatusState = async () => {
        let statusData = {
            status:
                rowData.status === false || rowData.status === "false"
                    ? false
                    : true,
        };
        setIsOpenStatusModal(false);
        // If activating a POST_PROCESSING param, deactivate others first
        if (statusData.status === true && 
            (rowData.process_code === 'POST_PROCESSING' || rowData.process_code === 'PostProcessing')) {
            await deactivateOtherPostProcessingParams();
        }
        if (statusData.status === true && 
            (rowData.process_code === 'DIARIZATION' || rowData.process_code === 'Diarization')) {
            await deactivateOtherDiarizationParams();
        }
        try {
            await axios
                .patch(
                    `${PROJECT_URL}/projects/params/status/${sessionStorage.getItem(
                        "projectCode"
                    )}/${rowData._id || rowData.id}`, statusData, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            "access_token"
                        )}`,
                    },
                })
                .then((response) => {
                    responseStateHandler(response.data.message, true);
                    ReloadData();
                });
        } catch (error) {
            const errorMessage = handleApiError(error);
            responseStateHandler(errorMessage, false);
        }
    };

    const [isOpenConfirmPopup, setIsOpenConfirmPopup] = useState(false);
    const [confirmationMsg, setConfirmationMsg] = useState("");

    function closeConfirmPopup() {
        setIsOpenConfirmPopup(false);
    }

    function openConfirmPopup(e) {
        setRowData(e);
        setConfirmationMsg(`Are you sure that you want to delete - ${e.param_code} parameters?`);
        setIsOpenConfirmPopup(true);
    }

    const handleDeleteState = async () => {
        setIsOpenConfirmPopup(false);
        try {
            await axios
                .delete(
                    `${PROJECT_URL}/projects/params/${sessionStorage.getItem(
                        "projectCode"
                    )}/${rowData._id || rowData.id}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            "access_token"
                        )}`,
                    },
                })
                .then((response) => {
                    responseStateHandler(response.data.message, true);
                    ReloadData();
                });
        } catch (error) {
            const errorMessage = handleApiError(error);
            responseStateHandler(errorMessage, false);
        }
    };

    const JsonDownloadButton = ({ disabled, content, fileName }) => {
        const downloadJson = () => {
            const blob = new Blob([JSON.stringify(content)], { type: 'application/json' });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName + ".json";
            link.click();
        };

        return (
            <button
                className="disabled:text-gray-300 items-center hover:bg-gray-200 hover:text-blue-600 flex w-full text-sm"
                disabled={disabled}
                onClick={downloadJson}
            >
                <p className="flex items-center px-4 py-2 w-full text-sm">
                    <ArrowDownTrayIcon className="h-4 text-blue-600 mr-2" />
                    <span>Download</span>
                </p>
            </button>
        );
    };

    // const copyToClipboard = (text) => {
    //     navigator.clipboard.writeText(text).then(
    //         () => {
    //             setMsg('Text copied to clipboard');
    //             setIsSuccess(true);
    //             setIsOpenPopup(true);
    //         },
    //         (err) => {
    //             setMsg('Failed to copy text', err);
    //             setIsSuccess(false);
    //             setIsOpenPopup(true);
    //         }
    //     );
    // };

    const [sorting, setSorting] = React.useState([]);


    const columns = React.useMemo(
        () => [
            {
                accessorKey: "index",
                enableColumnFilter: false,
                enableSorting: false,
                size: 40,
                header: "#",
                cell: ({ row }) => <center>{row.index + 1}</center>,
            },
            {
                accessorKey: "process_code",
                enableColumnFilter: false,
                size: 250,
                header: () => <span>Process Code</span>,
            },
            {
                accessorKey: "param_code",
                enableColumnFilter: false,
                size: 250,
                header: () => <span>Param Code</span>,
            },
            {
                accessorKey: "creation_date",
                enableColumnFilter: false,
                size: 300,
                header: "Created Date",
                cell: ({ row }) => (
                    <div>{formattedDate(row.original.creation_date)}</div>
                ),
            },
            {
                accessorKey: "creation_by",
                enableColumnFilter: false,
                size: 50,
                header: "Created By",
                cell: ({ row }) => (
                    <span className="capitalize" title={row.original.creation_by}>
                        {row.original.creation_by !== null
                            ? row.original.creation_by.slice(0, 12) +
                            (row.original.creation_by.length > 12
                                ? "..."
                                : "")
                            : null}
                    </span>
                ),
            },
            {
                accessorKey: "status",
                header: "Status",
                size: 50,
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => (
                    <div className="flex justify-center">
                        <div
                            onClick={() => openStatusModal(row.original)}
                            className={`${row.original.status === true
                                ? "bg-green-300  text-green-900"
                                : "bg-red-300 text-red-900"
                                } text-xs w-fit px-2 py-1 font-bold rounded-xl cursor-default lg:cursor-pointer`}
                        >
                            {row.original.status === true
                                ? "Active"
                                : "Inactive"}
                        </div>
                    </div>
                ),
            },
            // {
            //     accessorKey: "id",
            //     header: "Actions",
            //     size: 50,
            //     enableColumnFilter: false,
            //     enableSorting: false,
            //     cell: ({ row }) => (
            //         <div className="flex gap-2 items-center justify-center">
            //             <Menu as="div">
            //                 <div ref={(el) => (buttonRefs.current[row.original.id] = el)}>
            //                     <Menu.Button className="relative border bg-gray-50 rounded-md p-1 text-blue-800 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer"
            //                         onClick={(e) => {
            //                             e.stopPropagation();
            //                             calculatePosition(row.original.id)
            //                         }
            //                         }
            //                     >
            //                         <EllipsisHorizontalIcon className="h-4 text-black" />
            //                     </Menu.Button>
            //                 </div>
            //                 <Portal>
            //                     <Transition
            //                         as={Fragment}
            //                         show={activeDropdown === row.original.id}
            //                         enter="transition ease-out duration-100"
            //                         enterFrom="transform opacity-0 scale-95"
            //                         enterTo="transform opacity-100 scale-100"
            //                         leave="transition ease-in duration-75"
            //                         leaveFrom="transform opacity-100 scale-100"
            //                         leaveTo="transform opacity-0 scale-95"
            //                     >
            //                         <Menu.Items className="absolute z-50 right-8 md:right-24 mt-1 w-fit rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            //                             style={{
            //                                 top: `${dropdownPosition.top}px`,
            //                             }}
            //                             ref={dropdownRef}
            //                         >
            //                             <button
            //                                 className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-green-800 w-full text-sm"
            //                                 onClick={() => {
            //                                     openReadModal(row.original);
            //                                     setActiveDropdown(null);
            //                                 }}

            //                             >
            //                                 <EyeIcon className="h-4 text-green-800 mr-2" />
            //                                 <span>Show</span>
            //                             </button>
            //                             {/* <button
            //                                 className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-green-800 w-full text-sm"
            //                                 onClick={() => {
            //                                     copyToClipboard(JSON.stringify(row.original.params));
            //                                     setActiveDropdown(null);
            //                                 }}
            //                             >
            //                                 <DocumentDuplicateIcon className="h-4 text-green-800 mr-2" />
            //                                 <span>Copy</span>
            //                             </button> */}
            //                             <button
            //                                 className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-blue-800  w-full text-sm"
            //                                 onClick={() => {
            //                                     openModal(row.original, "edit");
            //                                     // openModal(row.original.id, "edit");
            //                                     setActiveDropdown(null);
            //                                 }}
            //                             >
            //                                 <PencilIcon className="h-4 text-blue-800 mr-2" />
            //                                 <span>Edit</span>
            //                             </button>
            //                             <JsonDownloadButton
            //                                 disabled={row.original.params ? false : true}
            //                                 content={row.original.params}
            //                                 fileName={row.original.param_code}
            //                                 onClick={() => {
            //                                     setActiveDropdown(null);
            //                                 }}
            //                             />
            //                             <button
            //                                 className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-red-800  w-full text-sm"
            //                                 onClick={() => {
            //                                     openConfirmPopup(row.original);
            //                                     setActiveDropdown(null);
            //                                 }}
            //                             >
            //                                 <TrashIcon className="h-4 text-red-600 mr-2" />
            //                                 <span>Delete</span>
            //                             </button>
            //                         </Menu.Items>
            //                     </Transition>
            //                 </Portal>
            //             </Menu>
            //         </div>
            //     ),
            // },
            // The issue is in your table column definition for Actions
            // Replace your Actions column cell with this fixed version:
            {
                accessorKey: "id",
                header: "Actions",
                size: 50,
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => {
                    const currentRowData = row.original;
                    
                    return (
                        <div className="flex gap-2 items-center justify-center">
                            <Menu as="div">
                                <div ref={(el) => (buttonRefs.current[currentRowData.id] = el)}>
                                    <Menu.Button 
                                        className="relative border bg-gray-50 rounded-md p-1 text-blue-800 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            console.log("Menu button clicked for:", currentRowData.param_code, currentRowData.process_code);
                                            // Pass rowData to calculatePosition
                                            calculatePosition(currentRowData.id, currentRowData);
                                        }}
                                    >
                                        <EllipsisHorizontalIcon className="h-4 text-black" />
                                    </Menu.Button>
                                </div>
                                <Portal>
                                    <Transition
                                        as={Fragment}
                                        show={activeDropdown === currentRowData.id}
                                        enter="transition ease-out duration-100"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                    >
                                        <Menu.Items 
                                            className="absolute z-50 right-8 md:right-24 mt-1 w-fit rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                            style={{
                                                top: `${dropdownPosition.top}px`,
                                            }}
                                            ref={dropdownRef}
                                        >
                                            {/* Use activeRowData instead of currentRowData in all onClick handlers */}
                                            <button
                                                className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-green-800 w-full text-sm"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    console.log("Show clicked - activeRowData:", activeRowData?.param_code);
                                                    if (activeRowData) {
                                                        openReadModal(activeRowData);
                                                    }
                                                    setActiveDropdown(null);
                                                }}
                                            >
                                                <EyeIcon className="h-4 text-green-800 mr-2" />
                                                <span>Show</span>
                                            </button>
                                            
                                            <button
                                                className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-blue-800 w-full text-sm"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    console.log("Edit clicked - activeRowData:", activeRowData?.param_code, activeRowData?.process_code);
                                                    if (activeRowData) {
                                                        openModal(activeRowData, "edit");
                                                    }
                                                    setActiveDropdown(null);
                                                }}
                                            >
                                                <PencilIcon className="h-4 text-blue-800 mr-2" />
                                                <span>Edit</span>
                                            </button>
                                            
                                            <div onClick={(e) => {
                                                e.stopPropagation();
                                                setActiveDropdown(null);
                                            }}>
                                                <JsonDownloadButton
                                                    disabled={activeRowData?.params ? false : true}
                                                    content={activeRowData?.params}
                                                    fileName={activeRowData?.param_code}
                                                />
                                            </div>
                                            
                                            <button
                                                className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-red-800 w-full text-sm"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    console.log("Delete clicked - activeRowData:", activeRowData?.param_code);
                                                    if (activeRowData) {
                                                        openConfirmPopup(activeRowData);
                                                    }
                                                    setActiveDropdown(null);
                                                }}
                                            >
                                                <TrashIcon className="h-4 text-red-600 mr-2" />
                                                <span>Delete</span>
                                            </button>
                                        </Menu.Items>
                                    </Transition>
                                </Portal>
                            </Menu>
                        </div>
                    );
                }
            }
        ],
        [activeDropdown, calculatePosition, dropdownPosition.top, openModal]
    );

    // const [data, setData] = useState([]);

    const [globalFilter, setGlobalFilter] = React.useState("");
    const [pageIndex, setPageIndex] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(initialpageSize);

    const pagination = React.useMemo(
        () => ({
            pageIndex,
            pageSize,
        }),
        [pageIndex, pageSize]
    );

    const table = useReactTable({
        data: data,
        columns,
        state: {
            sorting,
            pagination,
            globalFilter,
        },
        onGlobalFilterChange: setGlobalFilter,
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel()
    });

    const tableContainerRef = React.useRef(null);
    // Modify the pagination section
    const pageCount = Math.ceil(data.length / pageSize);
    const pageNumbers = [];

    for (let i = 0; i < pageCount; i++) {
        pageNumbers.push(i);
    }

    const handlePageChange = (e) => {
        const newPageSize = Number(e.target.value);
        setPageSize(newPageSize);
        setPageIndex(0);
    };

    function Filter({ column }) {
        const columnFilterValue = column.getFilterValue();
        return (
            <input
                type="text"
                value={columnFilterValue}
                onChange={(e) => column.setFilterValue(e.target.value)}
                placeholder={`Search...`}
                className="w-full border rounded-md text-xs"
            />
        );
    }

    const { rows } = table.getRowModel();
    const rowVirtualizer = useVirtualizer({
    count: rows.length,
    getScrollElement: () => tableContainerRef.current ?? null, // ALWAYS return a function
    estimateSize: () => 50,
    overscan: 10,
    });
    const { virtualItems: virtualRows, totalSize } = rowVirtualizer;

    // const paddingTop = virtualRows.length > 0 ? virtualRows[0]?.start || 0 : 0;
    // const paddingBottom =
    //     virtualRows.length > 0
    //         ? totalSize - (virtualRows[virtualRows.length - 1]?.end || 0)
    //         : 0;
    const safeVirtualRows = virtualRows || []; // default to empty array
    const paddingTop = safeVirtualRows.length > 0 ? safeVirtualRows[0]?.start || 0 : 0;
    const paddingBottom =
        safeVirtualRows.length > 0
            ? totalSize - (safeVirtualRows[safeVirtualRows.length - 1]?.end || 0)
            : 0;

    // useEffect(() => {
    //     const fetchInitialData = async () => {
    //         axios
    //             .get(
    //                 `${PROJECT_URL}/projects/params/${sessionStorage.getItem(
    //                     "projectCode"
    //                 )}`,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem(
    //                             "access_token"
    //                         )}`,
    //                     },
    //                 }
    //             )
    //             .then((response) => {
    //                 setData(response.data.data);
    //             })
    //             .catch((error) => {
    //                 const errorMessage = handleApiError(error);
    //                 setMsg(errorMessage);
    //                 setIsSuccess(false);
    //                 openPopup();
    //             }).finally(()=>{
    //                 setTimeout(() => {
    //                     setLoader(false);
    //                 },200)
    //             });
    //     };
    //     const fetchAllProcessFieldsData = async () => {
    //         axios
    //             .get(
    //                 `${PROJECT_URL}/projects/processes/allfields`,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem(
    //                             "access_token"
    //                         )}`,
    //                     },
    //                 }
    //             )
    //             .then((response) => {
    //                 console.log("API Response:", response.data);
    //                 console.log("Processes data:", response.data.data);
    //                 setProcesses(response.data.data);
    //             })
    //             .catch((error) => {
    //                 const errorMessage = handleApiError(error);
    //                 setMsg(errorMessage);
    //                 setIsSuccess(false);
    //                 openPopup();
    //             }).finally(()=>{
    //                 setTimeout(() => {
    //                     setLoader(false);
    //                 },200)
    //             });
    //     };
    //     fetchInitialData();
    //     fetchAllProcessFieldsData();
    // }, []);

    useEffect(() => {
        const fetchInitialData = async () => {
            axios
                .get(
                    `${PROJECT_URL}/projects/params/${sessionStorage.getItem(
                        "projectCode"
                    )}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                "access_token"
                            )}`,
                        },
                    }
                )
                .then((response) => {
                    setData(response.data.data);
                })
                .catch((error) => {
                    const errorMessage = handleApiError(error);
                    setMsg(errorMessage);
                    setIsSuccess(false);
                    openPopup();
                }).finally(()=>{
                    setTimeout(() => {
                        setLoader(false);
                    },200)
                });
        };
        
        const fetchAllProcessFieldsData = async () => {
            axios
                .get(
                    `${PROJECT_URL}/projects/processes/allfields`,
                    // `${PROJECT_URL}/processes/allfields`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                "access_token"
                            )}`,
                        },
                    }
                )
                .then((response) => {
                    console.log("API Response:", response.data);
                    console.log("Processes data:", response.data.data);
                    setProcesses(response.data.data);
                })
                .catch((error) => {
                    const errorMessage = handleApiError(error);
                    setMsg(errorMessage);
                    setIsSuccess(false);
                    openPopup();
                });
                // ❌ REMOVE THIS .finally() block - it was setting loader to false too early
                // .finally(()=>{
                //     setTimeout(() => {
                //         setLoader(false);
                //     },200)
                // });
        };
        
        fetchInitialData();
        fetchAllProcessFieldsData();
    }, []);

    useEffect(() => {
        console.log("Current table data order:", data.map(d => ({ 
            param: d.param_code, 
            process: d.process_code 
        })));
    }, [data]);

    // useEffect(() => {
    //     if (!isOpen) {
    //         setSelectedProcess('');
    //     }
    // }, [isOpen]);
    useEffect(() => {
        if (!isOpen) {
            // Add small delay before clearing to prevent race conditions
            const timer = setTimeout(() => {
                setSelectedProcess('');
                setFormState([]);
                setCategories([]);
                setSelectedSubCategories([]);
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    // const fileMap = {
    //     'TRANSCRIPT': '/downloads/transcript.json',
    //     'GETIDEAS': '/downloads/get_ideas.json',
    //     'REFINED': '/downloads/refined_answers.json',
    //     'RAW': '/downloads/raw_answers.json',
    // };

    // const downloadFile = (processCode) => {
    //     // Get the URL for the selected process
    //     const fileUrl = fileMap[processCode];

    //     // Check if the file URL exists for the selected process
    //     if (fileUrl) {
    //         const link = document.createElement('a');
    //         link.href = fileUrl;
    //         link.download = fileUrl.split('/').pop();
    //         link.click();
    //     } else {
    //         console.error('No file mapped for this process.');
    //     }
    // };
    
      const handleCheckboxChange = (index) => {
        const updatedFormState = [...formState];
        updatedFormState[index].checked = !updatedFormState[index].checked;
        setFormState(updatedFormState);
      };
    
      const handleInputChange = (index, value) => {
        const updatedFormState = [...formState];
        updatedFormState[index].defaultValue = value;
        setFormState(updatedFormState);
      };

      const handleNestedCheckboxChange = (index, nestedindex) => {
        const updatedFormState = [...formState];
        updatedFormState[index].nestedFields[nestedindex].checked = !updatedFormState[index].nestedFields[nestedindex].checked;
        setFormState(updatedFormState);
      };
    
      const handleNestedInputChange = (index, nestedindex, value) => {
        const updatedFormState = [...formState];
        updatedFormState[index].nestedFields[nestedindex].defaultValue = value;
        setFormState(updatedFormState);
      };


    return (
        <div className="border bg-white font-GoogleSans tracking-wider overflow-hidden">
            <ConfirmationPopup
                isOpenConfirmPopup={isOpenConfirmPopup}
                confirmationMsg={confirmationMsg}
                closeConfirmPopup={closeConfirmPopup}
                onStateChange={handleDeleteState}
            />
            <Popup
                isOpen={isOpenPopup}
                msg={msg}
                closeModal={closePopup}
                isSuccess={isSuccess}
            />
            <ReadModal
                isOpen={isOpenRead}
                closeModal={closeReadModal}
                title={modalTitle}
                modalInputs={
                    <div className="overflow-auto h-[calc(100vh-8rem)] md:h-[calc(100vh-8rem)]">
                        <pre className="pretxtwrap text-sm">
                            {/* {JSON.stringify(rowData.params, null, 2)} */}
                            {rowData && rowData.params 
                                ? JSON.stringify(rowData.params, null, 2)
                                : 'No parameters available'}
                        </pre>
                    </div>
                }
            />
            {/* <InputModal
                isOpen={isOpen}
                closeModal={closeModal}
                maxw="max-w-2xl"
                outerTouchClose={false}
                inputcls="px-0"
                title={
                    edit === false ? "Add Parameters" : "Overwrite Parameters"
                }
                savefn={edit === false ? handleCreateState : handleEditState}
                modalInputs={
                    <div className="space-y-5 px-4 pb-4 h-[calc(100dvh-20rem)] overflow-y-auto">
                            
                                {!edit && (
                                    <div>
                                    <label
                                        htmlFor="name"
                                        className="block text-sm tracking-wider mt-4 text-gray-500 mb-1"
                                    >
                                        Process
                                    </label>
                                    <select
                                        id="process"
                                        name="process"
                                        className="block w-full rounded-md border-0 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300 text-sm"
                                        onChange={(e) =>
                                            {
                                                const selectedCode = e.target.value;
                                                setSelectedProcess(selectedCode);
                                                if(!edit){
                                                    // Find the matching process and set form data
                                                    // const selectedProcess = processes.find((item) => item.process_code === selectedCode);
                                                    // setCategories(selectedProcess ? selectedProcess.categories: []);
                                                    // setFormState(selectedProcess ? selectedProcess.fields : []);
                                                    // setSelectedSubCategories([]);
                                                    const selectedProcessObj = processes.find(item => item.process_code === selectedCode);

                                                    setCategories(selectedProcessObj ? selectedProcessObj.categories : []);

                                                    setShowAllFields(
                                                        !selectedProcessObj || selectedProcessObj.categories.length === 0
                                                    );

                                                    setFormState(selectedProcessObj ? selectedProcessObj.fields : []);
                                                }
                                            }
                                        }
                                    >
                                        <option value="">Select Process</option>
                                        {processes.map((process, index) => (
                                            <option
                                                key={index}
                                                value={process.process_code}
                                            >
                                                {process.process_name}
                                            </option>
                                        ))}
                                    </select>
                                    </div>)}
                                    <div>
                                    {!showAllFields && categories?.map((category) => (
                                        <div key={category.id} className="border p-4 rounded-lg bg-gray-100 mt-3">
                                            <label className="block text-sm text-gray-500 mb-2">{category.name}</label>

                                            <select
                                            className="w-full p-2 rounded-md border-none ring-1 ring-gray-300 focus:ring-gray-300 bg-white text-sm"
                                            value={selectedSubCategories.find((id) =>
                                                category.subcategories.some((sub) => sub.id === id)
                                              )}
                                            onChange={(e) => handleSelectionChange(category.id, e.target.value)}
                                            >
                                                <option value="">select an option</option>
                                                {category?.subcategories?.map((sub) => (
                                                <option key={sub.id} value={sub.id}>
                                                {sub.name}
                                                </option>
                                            ))}
                                            </select>
                                        </div>
                                    ))}
                                    <form className={`space-y-3 pt-3`}> */}
                                    {/* {!edit && formState.length===0 && <p className="text-xs xl:text-sm p-2 bg-gray-100 rounded-lg">Please select a process</p>} */}
                                    {/* {(showAllFields || selectedSubCategories.length>0) && formState && formState?.map((field, index) => { */}
                                    {/* {(showAllFields || selectedSubCategories.length > 0 || (edit && formState.length > 0)) && formState && formState?.map((field, index) => {
                                        const shouldHide =
                                        selectedSubCategories.length === 0 ||
                                        (field.type === 'dict' && field.nestedFields &&
                                            field.nestedFields.every(nestedField =>
                                                !nestedField.useCategory ||
                                                !nestedField.subcategoryConfig ||
                                                !Object.keys(nestedField.subcategoryConfig).some(subCatKey =>
                                                    selectedSubCategories.includes(subCatKey) &&
                                                    nestedField.subcategoryConfig[subCatKey]?.action === "editable"
                                                )
                                            ) &&
                                            !field.nestedFields.some(nestedField => nestedField.isEditable) // Condition 3: Keep if any is editable
                                        ) ||
                                        (( !field.nestedFields || field.nestedFields.length === 0 ) &&
                                            (!field.useCategory ||
                                            !field.subcategoryConfig ||
                                            !Object.keys(field.subcategoryConfig).some(subCatKey => 
                                                selectedSubCategories.includes(subCatKey) &&
                                                field.subcategoryConfig[subCatKey]?.action === "editable"
                                            ))
                                        ); */}
                                        {/* return (
                                        <div key={index} className={`${!showAllFields && selectedSubCategories.length>0 && ((field.isEditable && field.isEditable===false) || shouldHide) && 'hidden'} p-3 border rounded-lg bg-gray-100 text-sm space-y-2`}>
                                        <label className="block w-fit cursor-default lg:cursor-pointer" htmlFor={`check_${index}`}>
                                            {!field.required && <input
                                                id={`check_${index}`}
                                                name={`check_${index}`}
                                                type="checkbox"
                                                className="h-4 w-4 mb-0.5 me-1.5 rounded border text-indigo-600 focus:ring-gray-300 disabled:text-gray-500"
                                                checked={field.checked}
                                                disabled={field.required} // Disable for required fields
                                                onChange={() => handleCheckboxChange(index)}
                                            />}
                                            <span className={`${!field.required && 'ms-0.5'}`}>{field.alias || field.key}</span>
                                        </label>            
                                        {field.checked && (field.type==="dict" && (field.nestedFields && field.nestedFields.length>0)) &&
                                           field.nestedFields.map((nestedfield, nestedindex) => {
                                            const hasEditableSubcategory =
                                              nestedfield.subcategoryConfig &&
                                              Object.entries(nestedfield.subcategoryConfig).some(
                                                ([key, config]) =>
                                                  selectedSubCategories?.includes(key) && config.action === "editable"
                                              );
                                        
                                            return (
                                            <div key={`${index}_${nestedindex}`} className={`p-3 border rounded-lg bg-white space-y-2 
                                                 ${!showAllFields && !nestedfield.isEditable && !hasEditableSubcategory ? "hidden" : ""}`}>
                                            <label className="block w-fit cursor-default lg:cursor-pointer" htmlFor={`nestedcheck_${index}_${nestedindex}`}>
                                                {!nestedfield.required && <input
                                                    id={`nestedcheck_${index}_${nestedindex}`}
                                                    name={`nestedcheck_${index}_${nestedindex}`}
                                                    type="checkbox"
                                                    className="h-4 w-4 mb-0.5 me-1.5 rounded border text-indigo-600 focus:ring-gray-300 disabled:text-gray-500"
                                                    checked={nestedfield.checked}
                                                    disabled={nestedfield.required} // Disable for required fields
                                                    onChange={() => handleNestedCheckboxChange(index, nestedindex)}
                                                />}
                                                <span className={`${!field.required && 'ms-0.5'}`}>{nestedfield.alias || nestedfield.key}</span>
                                            </label>
                                            {nestedfield.checked && (nestedfield.type==="text" || nestedfield.type==="number") && 
                                                <input
                                                    type={nestedfield.type}
                                                    className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                                    value={nestedfield.defaultValue}
                                                    onChange={(e) => handleNestedInputChange(index, nestedindex, e.target.value)}
                                                    disabled={!nestedfield.checked}
                                                />
                                            }
                                            {nestedfield.checked && nestedfield.type === "boolean" && 
                                                <select
                                                    className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                                    value={nestedfield.defaultValue}
                                                    onChange={(e) => handleNestedInputChange(index, nestedindex, e.target.value)}
                                                    >
                                                    <option value="true">True</option>
                                                    <option value="false">False</option>
                                                </select>
                                            }
                                            {nestedfield.checked && nestedfield.type==="select" &&
                                                <select
                                                    className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                                    value={nestedfield.defaultValue}
                                                    onChange={(e) => handleNestedInputChange(index, nestedindex, e.target.value)}
                                                >
                                                    <option value="">Select an option</option>
                                                    {nestedfield.options.values.map((option, optIndex) => (
                                                        <option
                                                            key={`nest_${index}_${nestedindex}_${optIndex}`}
                                                            value={
                                                                nestedfield.options.captions
                                                                ? Object.values(option)[0]
                                                                : option
                                                            }
                                                        >
                                                            {nestedfield.options.captions
                                                            ? Object.keys(option)[0]
                                                            : option}
                                                        </option>
                                                    ))}
                                                </select>
                                            }
                                            {nestedfield.checked && (nestedfield.type==="array" || (nestedfield.type==="dict")) &&
                                                <textarea
                                                    className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                                    value={nestedfield.defaultValue}
                                                    onChange={(e) => handleNestedInputChange(index, nestedindex, e.target.value)}
                                                />
                                            }
                                            </div>
                                        )})}
                                        {field.checked && (field.type==="text" || field.type==="number") && 
                                            <input
                                                type={field.type}
                                                value={field.defaultValue}
                                                className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                                onChange={(e) => handleInputChange(index, e.target.value)}
                                                disabled={!field.checked}
                                            />
                                        }
                                        {field.checked && field.type === "boolean" && 
                                            <select
                                                className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                                value={field.defaultValue}
                                                onChange={(e) => handleInputChange(index, e.target.value)}
                                                >
                                                <option value="true">True</option>
                                                <option value="false">False</option>
                                            </select>
                                        }
                                        {field.checked && (field.type==="array" || (field.type==="dict" && (!field.nestedFields || field.nestedFields.length===0))) &&
                                            <textarea
                                                className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                                value={field.defaultValue}
                                                onChange={(e) => handleInputChange(index, e.target.value)}
                                            />
                                        }
                                        {field.checked && field.type==="select" &&
                                            <select
                                                className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                                value={field.defaultValue}
                                                onChange={(e) => handleInputChange(index, e.target.value)}
                                            >
                                                <option value="">Select an option</option>
                                                {field.options.values.map((option, optIndex) => (
                                                    <option
                                                        key={`select_${index}_${optIndex}`}
                                                        value={
                                                        field.options.captions
                                                            ? Object.values(option)[0]
                                                            : option
                                                        }
                                                    >
                                                        {field.options.captions
                                                        ? Object.keys(option)[0]
                                                        : option}
                                                    </option>
                                                ))}
                                            </select>
                                        }
                                        </div>
                                        )})}
                                    </form>
                                    </div> */}
                        {/* <div>
                            <label
                                htmlFor="cover-photo"
                                className="block text-sm font-medium leading-6 text-gray-900"
                            >
                                Parameters File
                            </label>
                            <div className="flex justify-center rounded-md border border-dashed border-gray-900 px-2 py-10">
                                <div
                                    {...getRootProps({ className: "dropzone" })}
                                >
                                    <input {...getInputProps()} />
                                    <div className="text-center">
                                        <div className="flex justify-center text-sm leading-6 text-gray-600">
                                            <label
                                                htmlFor="file-upload"
                                                className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-0 focus-within:border-white focus-within:ring-whitefocus-within:ring-offset-2 hover:text-indigo-500"
                                            >
                                                <span>
                                                    {files.length < 1
                                                        ? "Upload"
                                                        : "Re-Upload"}{" "}
                                                    a file
                                                </span>
                                            </label>
                                            <p className="pl-1">
                                                or drag and drop
                                            </p>
                                        </div>
                                        <p className="text-xs leading-5 text-gray-600">
                                            JSON up to 30MB
                                        </p>
                                        <aside>
                                            {files.map((file) => (
                                                <p
                                                    className="border py-3 px-2 mt-2 rounded-md text-sm"
                                                    key={file.path}
                                                >
                                                    {file.path} -{" "}
                                                    {convertBytesToMB(
                                                        file.size
                                                    )}
                                                </p>
                                            ))}
                                        </aside>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {/* {selectedProcess ? (
                            <div className="text-sm">
                                Click here to download sample file:
                                <div
                                    className="text-blue-600 cursor-pointer text-sm"
                                    onClick={() => downloadFile(selectedProcess)}
                                >
                                    {processes.find(p => p.process_code === selectedProcess)?.process_name}
                                </div>
                            </div>
                        ) : (
                            ""
                        )} 
                    </div>
                }
            /> */}
            <InputModal
                isOpen={isOpen}
                closeModal={closeModal}
                overflowVisible={true}
                maxw="max-w-2xl"
                outerTouchClose={false}
                inputcls="px-0"
                title={
                    edit === false ? "Add Parameters" : "Overwrite Parameters"
                }
                savefn={edit === false ? handleCreateState : handleEditState}
                modalInputs={
                    // <div className="space-y-5 px-4 pb-4 h-[calc(100dvh-20rem)] overflow-y-auto">
                    <div className="space-y-5 px-4 pb-4 max-h-[calc(100dvh-20rem)]" style={{overflowY: 'auto', overflowX: 'visible'}}>
                        
                        {/* {!edit && (
                            <div>
                            <label
                                htmlFor="name"
                                className="block text-sm tracking-wider mt-4 text-gray-500 mb-1"
                            >
                                Process
                            </label>
                            <select
                                id="process"
                                name="process"
                                className="block w-full rounded-md border-0 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300 text-sm"
                                // onChange={(e) =>
                                //     {
                                //         const selectedCode = e.target.value;
                                //         setSelectedProcess(selectedCode);
                                //         if(!edit){
                                //             const selectedProcessObj = processes.find(item => item.process_code === selectedCode);

                                //             setCategories(selectedProcessObj ? selectedProcessObj.categories : []);

                                //             setShowAllFields(
                                //                 !selectedProcessObj || selectedProcessObj.categories.length === 0
                                //             );

                                //             // setFormState(selectedProcessObj ? selectedProcessObj.fields : []);
                                //             const fields = selectedProcessObj ? selectedProcessObj.fields : [];
                                //             const updatedFields = fields.map(f => 
                                //                 ['pii_masking', 'keep_original_lang', 'enable_pre_process'].includes(f.key) 
                                //                     ? { ...f, checked: true } 
                                //                     : f
                                //             );
                                //             setFormState(updatedFields);
                                //         }
                                //     }
                                // }
                                onChange={(e) => {
                                    const selectedCode = e.target.value;
                                    setSelectedProcess(selectedCode);
                                    if(!edit){
                                        const selectedProcessObj = processes.find(item => item.process_code === selectedCode);

                                        setCategories(selectedProcessObj ? selectedProcessObj.categories : []);

                                        setShowAllFields(
                                            !selectedProcessObj || selectedProcessObj.categories.length === 0
                                        );

                                        let fields = selectedProcessObj ? selectedProcessObj.fields : [];
                                        
                                        // Add transcription fields if they don't exist
                                        if (selectedCode === 'TRANSCRIPT' || selectedCode === 'Transcription') {
                                            const transcriptFields = [
                                                { key: 'keep_original_lang', alias: 'Keep Original Language', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'enable_pre_process', alias: 'Enable Pre-processing', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'pii_masking', alias: 'PII Masking', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'pii_entities_list', alias: 'PII Entities List', type: 'text', checked: false, defaultValue: '' }
                                            ];
                                            
                                            transcriptFields.forEach(tf => {
                                                if (!fields.find(f => f.key === tf.key)) {
                                                    fields.push(tf);
                                                }
                                            });
                                        }

                                        setFormState(fields);
                                    }}
                                }
                            >
                                <option value="">Select Process</option>
                                {processes.map((process, index) => (
                                    <option
                                        key={index}
                                        value={process.process_code}
                                    >
                                        {process.process_name}
                                    </option>
                                ))}
                            </select>
                            </div>
                        )} */}
                        {!edit && (
                            <div>
                            <label
                                htmlFor="name"
                                className="block text-sm tracking-wider mt-4 text-gray-500 mb-1"
                            >
                                Process
                            </label>
                            <select
                                id="process"
                                name="process"
                                value={selectedProcess}
                                className="block w-full rounded-md border-0 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300 text-sm"
                                onChange={(e) => {
                                    const selectedCode = e.target.value;
                                    console.log("🔹 Process selected:", selectedCode);
                                    setSelectedProcess(selectedCode);
                                    
                                    if(!edit){
                                        const selectedProcessObj = processes.find(item => item.process_code === selectedCode);
                                        console.log("🔹 Selected process object:", selectedProcessObj);
                                        console.log("🔹 Categories:", selectedProcessObj?.categories);

                                        // let cats = selectedProcessObj ? selectedProcessObj.categories : [];
                                        let cats = selectedProcessObj?.categories || [];
                                        setCategories(cats);
                                        setSelectedSubCategories([]); // Reset subcategories when process changes
                                        
                                        // 🔧 TEMPORARY FIX: Add hardcoded categories for RAW process
                                        if (selectedCode === 'RAW' && cats.length === 0) {
                                            cats = [
                                                {
                                                    id: "input_type",
                                                    name: "Input Type Selection",
                                                    subcategories: [
                                                        { id: "paragraph", name: "Process from Paragraph" },
                                                        { id: "conversation", name: "Process from Conversation List" }
                                                    ]
                                                }
                                            ];
                                        }
                                        
                                        setCategories(cats);
                                        setSelectedSubCategories([]); // Reset subcategories when process changes

                                        const shouldShowAll = cats.length === 0;
                                        console.log("🔹 Should show all fields:", shouldShowAll, "Categories length:", cats.length);
                                        setShowAllFields(shouldShowAll);

                                        // let fields = selectedProcessObj ? selectedProcessObj.fields : [];
                                        let fields = selectedProcessObj?.fields || [];
                                        console.log("🔹 Fields from API:", fields);
                                        
                                        // // 🔧 TEMPORARY: Add sample fields for RAW if empty/minimal
                                        // if (selectedCode === 'RAW' && (!fields || fields.length <= 1)) {
                                        //     fields = [
                                        //         {
                                        //             key: "company_information",
                                        //             alias: "Company Information",
                                        //             type: "dict",
                                        //             checked: false,
                                        //             defaultValue: {},
                                        //             required: false,
                                        //             useCategory: true,
                                        //             subcategoryConfig: {
                                        //                 "paragraph": { action: "editable" },
                                        //                 "conversation": { action: "neglect" }
                                        //             },
                                        //             nestedFields: [
                                        //                 {
                                        //                     key: "company_info",
                                        //                     alias: "Company Info",
                                        //                     type: "text",
                                        //                     checked: false,
                                        //                     defaultValue: "",
                                        //                     isEditable: true
                                        //                 },
                                        //                 {
                                        //                     key: "competitor_company_info",
                                        //                     alias: "Competitor Company Info",
                                        //                     type: "text",
                                        //                     checked: false,
                                        //                     defaultValue: "",
                                        //                     isEditable: true
                                        //                 },
                                        //                 {
                                        //                     key: "company_aliases",
                                        //                     alias: "Company Aliases",
                                        //                     type: "array",
                                        //                     checked: false,
                                        //                     defaultValue: [],
                                        //                     isEditable: true
                                        //                 }
                                        //             ]
                                        //         }
                                        //     ];
                                        //     console.log("🔹 Using hardcoded RAW fields");
                                        // }
                                        
                                        // Add transcription fields if they don't exist
                                        if (selectedCode === 'TRANSCRIPT' || selectedCode === 'Transcription') {
                                            const transcriptFields = [
                                                { key: 'keep_original_lang', alias: 'Keep Original Language', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'enable_pre_process', alias: 'Enable Pre-processing', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'pii_masking', alias: 'PII Masking', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'pii_entities_list', alias: 'PII Entities List', type: 'text', checked: false, defaultValue: '' },
                                            ];
                                            
                                            transcriptFields.forEach(tf => {
                                                if (!fields.find(f => f.key === tf.key)) {
                                                    fields.push(tf);
                                                }
                                            });
                                        }

                                        if (selectedCode === 'GETIDEAS' || selectedCode === 'GET_IDEAS') {
                                            const getIdeasFields = [
                                                { key: 'get_topics', alias: 'Get Topics', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'get_sentiment', alias: 'Get Sentiment', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'get_aliases', alias: 'Get Aliases', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'get_ner', alias: 'Get NER', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'get_feature_list', alias: 'Get Feature List', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'industry', alias: 'Industry', type: 'text', checked: false, defaultValue: '' },
                                                { key: 'company_brand_names', alias: 'Company Brand Names', type: 'text', checked: false, defaultValue: '' },
                                                { key: 'feature_lst', alias: 'Feature List', type: 'text', checked: false, defaultValue: '' },
                                                { key: 'aliases', alias: 'Aliases', type: 'text', checked: false, defaultValue: '' }
                                            ];
                                            
                                            getIdeasFields.forEach(gf => {
                                                if (!fields.find(f => f.key === gf.key)) {
                                                    fields.push(gf);
                                                }
                                            });
                                        }

                                        // Add post processing fields if they don't exist
                                        if (selectedCode === 'POST_PROCESSING' || selectedCode === 'PostProcessing') {
                                            const postProcessFields = [
                                                { 
                                                    key: 'text_type', 
                                                    alias: 'Text Type', 
                                                    type: 'select', 
                                                    checked: true, 
                                                    required: false,
                                                    defaultValue: 'default',
                                                    hideInForm: true,
                                                    options: {
                                                        values: ['default', 'transcribed', 'diarized'],
                                                        captions: false
                                                    }
                                                }
                                            ];
                                            
                                            postProcessFields.forEach(pf => {
                                                if (!fields.find(f => f.key === pf.key)) {
                                                    fields.push(pf);
                                                }
                                            });
                                        }

                                        // Add Diarization fields if they don't exist
                                        if (selectedCode === 'DIARIZATION' || selectedCode === 'Diarization') {
                                            const diarizationFields = [
                                                { key: 'enable_fixes', alias: 'Enable Fixes', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'process_as_wav', alias: 'Process as WAV', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'pii_masking', alias: 'PII Masking', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'enable_pre_process', alias: 'Enable Pre-processing', type: 'number', checked: false, defaultValue: 0 },
                                                { key: 'keep_original_lang', alias: 'Keep Original Language', type: 'number', checked: false, defaultValue: 0 }
                                            ];
                                            
                                            diarizationFields.forEach(df => {
                                                if (!fields.find(f => f.key === df.key)) {
                                                    fields.push(df);
                                                }
                                            });
                                        }

                                        setFormState(fields);
                                    }
                                }}
                            >
                                <option value="">Select Process</option>
                                {processes.map((process, index) => (
                                    <option
                                        key={index}
                                        value={process.process_code}
                                    >
                                        {process.process_name}
                                    </option>
                                ))}
                            </select>
                            </div>
                        )}
                        <div>
                            {!showAllFields && categories?.map((category) => (
                                <div key={category.id} className="border p-4 rounded-lg bg-gray-100 mt-3">
                                    {/* Category Name */}
                                    <label className="block text-sm text-gray-500 mb-2">{category.name}</label>

                                    {/* Subcategories as Select Dropdown */}
                                    <select
                                    className="w-full p-2 rounded-md border-none ring-1 ring-gray-300 focus:ring-gray-300 bg-white text-sm"
                                    value={selectedSubCategories.find((id) =>
                                        category.subcategories.some((sub) => sub.id === id)
                                    )}
                                    onChange={(e) => handleSelectionChange(category.id, e.target.value)}
                                    >
                                        <option value="">select an option</option>
                                        {category?.subcategories?.map((sub) => (
                                        <option key={sub.id} value={sub.id}>
                                        {sub.name}
                                        </option>
                                    ))}
                                    </select>
                                </div>
                            ))}
                            
                            {/* ✅ TRANSCRIPTION CONFIGURATION FIELDS */}
                            {(selectedProcess === 'TRANSCRIPT' || selectedProcess === 'Transcription') && (
                                <div className="border-t pt-4 mt-4">
                                    <h3 className="text-sm font-medium text-gray-700 mb-3">Transcription Settings</h3>
                                    
                                    {/* Keep Original Language */}
                                    <div className="p-3 border rounded-lg bg-gray-50 mb-3">
                                        <label className="flex items-center justify-between cursor-pointer">
                                            <div>
                                                <span className="text-sm font-medium text-gray-700">Keep Original Language</span>
                                                <p className="text-xs text-gray-500 mt-1">Preserve the original language in transcription output</p>
                                            </div>
                                            <input
                                                type="checkbox"
                                                // checked={formState.find(f => f.key === 'keep_original_lang')?.defaultValue === 1}
                                                // checked={(() => {
                                                //     const field = formState.find(f => f.key === 'keep_original_lang');
                                                //     return field ? (field.checked && field.defaultValue === 1) : false;
                                                // })()}
                                                checked={formState.find(f => f.key === 'keep_original_lang')?.checked || false}
                                                // onChange={(e) => {
                                                //     const index = formState.findIndex(f => f.key === 'keep_original_lang');
                                                //     if (index !== -1) {
                                                //         handleInputChange(index, e.target.checked ? 1 : 0);
                                                //         if (e.target.checked && !formState[index].checked) {
                                                //             handleCheckboxChange(index);
                                                //         }
                                                //     }
                                                // }}
                                                onChange={(e) => {
                                                    {console.log('keep_original_lang field:', formState.find(f => f.key === 'keep_original_lang'))}
                                                    const isChecked = e.target.checked;
                                                    setFormState(prev => {
                                                        const newState = prev.map((f) =>
                                                            f.key === 'keep_original_lang'
                                                                ? { ...f, checked: isChecked, defaultValue: isChecked ? 1 : 0 }
                                                                : f
                                                        );
                                                        console.log('Updated formState:', newState.find(f => f.key === 'keep_original_lang'));
                                                        return newState;
                                                    });
                                                }}
                                                className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                            />
                                        </label>
                                    </div>

                                    {/* Enable Pre-process */}
                                    <div className="p-3 border rounded-lg bg-gray-50 mb-3">
                                        <label className="flex items-center justify-between cursor-pointer">
                                            <div>
                                                <span className="text-sm font-medium text-gray-700">Enable Pre-processing</span>
                                                <p className="text-xs text-gray-500 mt-1">Apply audio enhancement before transcription</p>
                                            </div>
                                            <input
                                                type="checkbox"
                                                // checked={formState.find(f => f.key === 'enable_pre_process')?.defaultValue === 1}
                                                checked={formState.find(f => f.key === 'enable_pre_process')?.checked || false}
                                                // onChange={(e) => {
                                                //     const index = formState.findIndex(f => f.key === 'enable_pre_process');
                                                //     if (index !== -1) {
                                                //         handleInputChange(index, e.target.checked ? 1 : 0);
                                                //         if (e.target.checked && !formState[index].checked) {
                                                //             handleCheckboxChange(index);
                                                //         }
                                                //     }
                                                // }}
                                                onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    setFormState(prev =>
                                                        prev.map((f) =>
                                                            f.key === 'enable_pre_process'
                                                                ? { ...f, checked: isChecked, defaultValue: isChecked ? 1 : 0 }
                                                                : f
                                                        )
                                                    );
                                                }}
                                                className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                            />
                                        </label>
                                    </div>

                                    {/* PII Masking */}
                                    <div className="p-3 border rounded-lg bg-gray-50">
                                        <label className="flex items-center justify-between cursor-pointer">
                                            <div>
                                                <span className="text-sm font-medium text-gray-700">PII Masking</span>
                                                <p className="text-xs text-gray-500 mt-1">Redact personally identifiable information</p>
                                            </div>
                                            <input
                                                type="checkbox"
                                                // checked={(() => {
                                                //     const field = formState.find(f => f.key === 'pii_masking');
                                                //     return field ? (field.checked && field.defaultValue === 1) : false;
                                                // })()}
                                                checked={formState.find(f => f.key === 'pii_masking')?.checked || false}
                                                // onChange={(e) => {
                                                //     const index = formState.findIndex(f => f.key === 'pii_masking');
                                                //     if (index !== -1) {
                                                //         handleInputChange(index, e.target.checked ? 1 : 0);
                                                //         if (e.target.checked && !formState[index].checked) {
                                                //             handleCheckboxChange(index);
                                                //         }
                                                //         // Clear pii_entities_list if disabling
                                                //         if (!e.target.checked) {
                                                //             const entitiesIndex = formState.findIndex(f => f.key === 'pii_entities_list');
                                                //             if (entitiesIndex !== -1) {
                                                //                 handleInputChange(entitiesIndex, '');
                                                //             }
                                                //         }
                                                //     }
                                                // }}
                                                onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    setFormState(prev =>
                                                        prev.map((f) =>
                                                            f.key === 'pii_masking'
                                                                ? { ...f, checked: isChecked, defaultValue: isChecked ? 1 : 0 }
                                                                : f
                                                        )
                                                    );
                                                }}
                                                className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                            />
                                        </label>

                                        {/* PII Entities List - Only show when PII Masking is enabled */}
                                        {formState.find(f => f.key === 'pii_masking')?.defaultValue === 1 && (
                                            <div className="mt-4 p-3 bg-white rounded-lg border">
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    PII Entity Types to Mask
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter entities separated by commas (e.g., PHONE_NUMBER, EMAIL_ADDRESS)"
                                                    value={formState.find(f => f.key === 'pii_entities_list')?.defaultValue || ''}
                                                    onChange={(e) => {
                                                        const index = formState.findIndex(f => f.key === 'pii_entities_list');
                                                        if (index !== -1) {
                                                            handleInputChange(index, e.target.value);
                                                            if (e.target.value && !formState[index].checked) {
                                                                handleCheckboxChange(index);
                                                            }
                                                        }
                                                    }}
                                                    className="block w-full rounded-md border-0 py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500"
                                                />
                                                <p className="text-xs text-gray-500 mt-2">
                                                    Common types: PHONE_NUMBER, EMAIL_ADDRESS, CREDIT_CARD, SSN, PERSON, LOCATION, DATE_TIME, IP_ADDRESS
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {/* ✅ END TRANSCRIPTION FIELDS */}

                            {/* GET_IDEAS Configuration Fields */}
                            {(selectedProcess === 'GETIDEAS' || selectedProcess === 'GET_IDEAS') && (
                                <div className="border-t pt-4 mt-4">
                                    <h3 className="text-sm font-medium text-gray-700 mb-3">Get Ideas Settings</h3>
                                    
                                    {/* Toggle Options - these won't appear in the regular form below */}
                                    <div className="space-y-3 mb-4">
                                        {/* Get Topics */}
                                        <div className="p-3 border rounded-lg bg-gray-50">
                                            <label className="flex items-center justify-between cursor-pointer">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-700">Get Topics</span>
                                                    <p className="text-xs text-gray-500 mt-1">Extract main topics from content</p>
                                                </div>
                                                <input
                                                    type="checkbox"
                                                    checked={(() => {
                                                        const field = formState.find(f => f.key === 'get_topics');
                                                        return field ? field.checked : true;
                                                    })()}
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        setFormState(prev => {
                                                            const exists = prev.find(f => f.key === 'get_topics');
                                                            if (exists) {
                                                                return prev.map((f) =>
                                                                    f.key === 'get_topics'
                                                                        ? { ...f, checked: isChecked, defaultValue: isChecked ? 1 : 0, hideInForm: true }
                                                                        : f
                                                                );
                                                            } else {
                                                                return [...prev, { 
                                                                    key: 'get_topics', 
                                                                    alias: 'Get Topics', 
                                                                    type: 'number', 
                                                                    checked: isChecked, 
                                                                    defaultValue: isChecked ? 1 : 0,
                                                                    hideInForm: true
                                                                }];
                                                            }
                                                        });
                                                    }}
                                                    className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                />
                                            </label>
                                        </div>

                                        {/* Get Sentiment */}
                                        <div className="p-3 border rounded-lg bg-gray-50">
                                            <label className="flex items-center justify-between cursor-pointer">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-700">Get Sentiment</span>
                                                    <p className="text-xs text-gray-500 mt-1">Analyze sentiment in content</p>
                                                </div>
                                                <input
                                                    type="checkbox"
                                                    checked={(() => {
                                                        const field = formState.find(f => f.key === 'get_sentiment');
                                                        return field ? field.checked : false;
                                                    })()}
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        setFormState(prev => {
                                                            const exists = prev.find(f => f.key === 'get_sentiment');
                                                            if (exists) {
                                                                return prev.map((f) =>
                                                                    f.key === 'get_sentiment'
                                                                        ? { ...f, checked: isChecked, defaultValue: isChecked ? 1 : 0, hideInForm: true }
                                                                        : f
                                                                );
                                                            } else {
                                                                return [...prev, { 
                                                                    key: 'get_sentiment', 
                                                                    alias: 'Get Sentiment', 
                                                                    type: 'number', 
                                                                    checked: isChecked, 
                                                                    defaultValue: isChecked ? 1 : 0,
                                                                    hideInForm: true
                                                                }];
                                                            }
                                                        });
                                                    }}
                                                    className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                />
                                            </label>
                                        </div>

                                        {/* Get Aliases */}
                                        <div className="p-3 border rounded-lg bg-gray-50">
                                            <label className="flex items-center justify-between cursor-pointer">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-700">Get Aliases</span>
                                                    <p className="text-xs text-gray-500 mt-1">Extract entity aliases</p>
                                                </div>
                                                <input
                                                    type="checkbox"
                                                    checked={(() => {
                                                        const field = formState.find(f => f.key === 'get_aliases');
                                                        return field ? field.checked : false;
                                                    })()}
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        setFormState(prev => {
                                                            const exists = prev.find(f => f.key === 'get_aliases');
                                                            if (exists) {
                                                                return prev.map((f) =>
                                                                    f.key === 'get_aliases'
                                                                        ? { ...f, checked: isChecked, defaultValue: isChecked ? 1 : 0, hideInForm: true }
                                                                        : f
                                                                );
                                                            } else {
                                                                return [...prev, { 
                                                                    key: 'get_aliases', 
                                                                    alias: 'Get Aliases', 
                                                                    type: 'number', 
                                                                    checked: isChecked, 
                                                                    defaultValue: isChecked ? 1 : 0,
                                                                    hideInForm: true
                                                                }];
                                                            }
                                                        });
                                                    }}
                                                    className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                />
                                            </label>
                                        </div>

                                        {/* Get NER */}
                                        <div className="p-3 border rounded-lg bg-gray-50">
                                            <label className="flex items-center justify-between cursor-pointer">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-700">Get NER</span>
                                                    <p className="text-xs text-gray-500 mt-1">Named Entity Recognition</p>
                                                </div>
                                                <input
                                                    type="checkbox"
                                                    checked={(() => {
                                                        const field = formState.find(f => f.key === 'get_ner');
                                                        return field ? field.checked : false;
                                                    })()}
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        setFormState(prev => {
                                                            const exists = prev.find(f => f.key === 'get_ner');
                                                            if (exists) {
                                                                return prev.map((f) =>
                                                                    f.key === 'get_ner'
                                                                        ? { ...f, checked: isChecked, defaultValue: isChecked ? 1 : 0, hideInForm: true }
                                                                        : f
                                                                );
                                                            } else {
                                                                return [...prev, { 
                                                                    key: 'get_ner', 
                                                                    alias: 'Get NER', 
                                                                    type: 'number', 
                                                                    checked: isChecked, 
                                                                    defaultValue: isChecked ? 1 : 0,
                                                                    hideInForm: true
                                                                }];
                                                            }
                                                        });
                                                    }}
                                                    className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                />
                                            </label>
                                        </div>

                                        {/* Get Feature List */}
                                        <div className="p-3 border rounded-lg bg-gray-50">
                                            <label className="flex items-center justify-between cursor-pointer">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-700">Get Feature List</span>
                                                    <p className="text-xs text-gray-500 mt-1">Extract product features</p>
                                                </div>
                                                <input
                                                    type="checkbox"
                                                    checked={(() => {
                                                        const field = formState.find(f => f.key === 'get_feature_list');
                                                        return field ? field.checked : false;
                                                    })()}
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        setFormState(prev => {
                                                            const exists = prev.find(f => f.key === 'get_feature_list');
                                                            if (exists) {
                                                                return prev.map((f) =>
                                                                    f.key === 'get_feature_list'
                                                                        ? { ...f, checked: isChecked, defaultValue: isChecked ? 1 : 0, hideInForm: true }
                                                                        : f
                                                                );
                                                            } else {
                                                                return [...prev, { 
                                                                    key: 'get_feature_list', 
                                                                    alias: 'Get Feature List', 
                                                                    type: 'number', 
                                                                    checked: isChecked, 
                                                                    defaultValue: isChecked ? 1 : 0,
                                                                    hideInForm: true
                                                                }];
                                                            }
                                                        });
                                                    }}
                                                    className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    {/* Input Fields */}
                                    <div className="space-y-4">
                                        {/* Industry */}
                                        <div className="p-3 bg-white rounded-lg border">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Industry
                                                <p className="text-xs text-gray-500 mt-1">Specify the industry domain</p>
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="e.g., Automobile"
                                                value={(() => {
                                                    const field = formState.find(f => f.key === 'industry');
                                                    return field ? (field.defaultValue || '') : '';
                                                })()}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setFormState(prev => {
                                                        const exists = prev.find(f => f.key === 'industry');
                                                        if (exists) {
                                                            return prev.map((f) =>
                                                                f.key === 'industry'
                                                                    ? { ...f, checked: true, defaultValue: value, hideInForm: true }
                                                                    : f
                                                            );
                                                        } else {
                                                            return [...prev, { 
                                                                key: 'industry', 
                                                                alias: 'Industry', 
                                                                type: 'text', 
                                                                checked: true, 
                                                                defaultValue: value,
                                                                hideInForm: true
                                                            }];
                                                        }
                                                    });
                                                }}
                                                className="block w-full rounded-md border-0 py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500"
                                            />
                                        </div>

                                        {/* Company Brand Names */}
                                        <div className="p-3 bg-white rounded-lg border">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Company Brand Names (JSON)
                                                <p className="text-xs text-gray-500 mt-1">Format: {`{"Tesla": ["Model Y", "Model 3"]}`}</p>
                                            </label>
                                            <textarea
                                                rows="3"
                                                placeholder='{"Tesla": ["Model Y", "Model 3"]}'
                                                value={(() => {
                                                    const field = formState.find(f => f.key === 'company_brand_names');
                                                    return field ? (field.defaultValue || '') : '';
                                                })()}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setFormState(prev => {
                                                        const exists = prev.find(f => f.key === 'company_brand_names');
                                                        if (exists) {
                                                            return prev.map((f) =>
                                                                f.key === 'company_brand_names'
                                                                    ? { ...f, checked: true, defaultValue: value, hideInForm: true }
                                                                    : f
                                                            );
                                                        } else {
                                                            return [...prev, { 
                                                                key: 'company_brand_names', 
                                                                alias: 'Company Brand Names', 
                                                                type: 'text', 
                                                                checked: true, 
                                                                defaultValue: value,
                                                                hideInForm: true
                                                            }];
                                                        }
                                                    });
                                                }}
                                                className="block w-full rounded-md border-0 py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500 font-mono"
                                            />
                                        </div>

                                        {/* Feature List */}
                                        <div className="p-3 bg-white rounded-lg border">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Feature List
                                                <p className="text-xs text-gray-500 mt-1">Comma-separated features (e.g., safety, performance, pricing)</p>
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="safety, performance, pricing"
                                                value={(() => {
                                                    const field = formState.find(f => f.key === 'feature_lst');
                                                    return field ? (field.defaultValue || '') : '';
                                                })()}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setFormState(prev => {
                                                        const exists = prev.find(f => f.key === 'feature_lst');
                                                        if (exists) {
                                                            return prev.map((f) =>
                                                                f.key === 'feature_lst'
                                                                    ? { ...f, checked: true, defaultValue: value, hideInForm: true }
                                                                    : f
                                                            );
                                                        } else {
                                                            return [...prev, { 
                                                                key: 'feature_lst', 
                                                                alias: 'Feature List', 
                                                                type: 'text', 
                                                                checked: true, 
                                                                defaultValue: value,
                                                                hideInForm: true
                                                            }];
                                                        }
                                                    });
                                                }}
                                                className="block w-full rounded-md border-0 py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500"
                                            />
                                        </div>

                                        {/* Aliases */}
                                        <div className="p-3 bg-white rounded-lg border">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Aliases (JSON)
                                                <p className="text-xs text-gray-500 mt-1">Format: {`{"Tesla": ["Teslla"]}`}</p>
                                            </label>
                                            <textarea
                                                rows="3"
                                                placeholder='{"Tesla": ["Teslla"]}'
                                                value={(() => {
                                                    const field = formState.find(f => f.key === 'aliases');
                                                    return field ? (field.defaultValue || '') : '';
                                                })()}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setFormState(prev => {
                                                        const exists = prev.find(f => f.key === 'aliases');
                                                        if (exists) {
                                                            return prev.map((f) =>
                                                                f.key === 'aliases'
                                                                    ? { ...f, checked: true, defaultValue: value, hideInForm: true }
                                                                    : f
                                                            );
                                                        } else {
                                                            return [...prev, { 
                                                                key: 'aliases', 
                                                                alias: 'Aliases', 
                                                                type: 'text', 
                                                                checked: true, 
                                                                defaultValue: value,
                                                                hideInForm: true
                                                            }];
                                                        }
                                                    });
                                                }}
                                                className="block w-full rounded-md border-0 py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500 font-mono"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                            {/* END GET_IDEAS FIELDS */}

                            {/* DIARIZATION Configuration Fields */}
                            {(selectedProcess === 'DIARIZATION' || selectedProcess === 'Diarization') && (
                                <div className="border-t pt-4 mt-4">
                                    <h3 className="text-sm font-medium text-gray-700 mb-3">Diarization Settings</h3>
                                    
                                    <div className="space-y-3">
                                        {/* Enable Fixes */}
                                        <div className="p-3 border rounded-lg bg-gray-50">
                                            <label className="flex items-center justify-between cursor-pointer">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-700">Enable Fixes</span>
                                                    <p className="text-xs text-gray-500 mt-1">Apply automatic fixes to diarization</p>
                                                </div>
                                                <input
                                                    type="checkbox"
                                                    checked={formState.find(f => f.key === 'enable_fixes')?.checked || false}
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        setFormState(prev =>
                                                            prev.map((f) =>
                                                                f.key === 'enable_fixes'
                                                                    ? { ...f, checked: isChecked, defaultValue: isChecked ? 1 : 0 }
                                                                    : f
                                                            )
                                                        );
                                                    }}
                                                    className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                />
                                            </label>
                                        </div>

                                        {/* Process as WAV */}
                                        <div className="p-3 border rounded-lg bg-gray-50">
                                            <label className="flex items-center justify-between cursor-pointer">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-700">Process as WAV</span>
                                                    <p className="text-xs text-gray-500 mt-1">Convert audio to WAV format before processing</p>
                                                </div>
                                                <input
                                                    type="checkbox"
                                                    checked={formState.find(f => f.key === 'process_as_wav')?.checked || false}
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        setFormState(prev =>
                                                            prev.map((f) =>
                                                                f.key === 'process_as_wav'
                                                                    ? { ...f, checked: isChecked, defaultValue: isChecked ? 1 : 0 }
                                                                    : f
                                                            )
                                                        );
                                                    }}
                                                    className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                />
                                            </label>
                                        </div>

                                        {/* PII Masking */}
                                        <div className="p-3 border rounded-lg bg-gray-50">
                                            <label className="flex items-center justify-between cursor-pointer">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-700">PII Masking</span>
                                                    <p className="text-xs text-gray-500 mt-1">Redact personally identifiable information</p>
                                                </div>
                                                <input
                                                    type="checkbox"
                                                    checked={formState.find(f => f.key === 'pii_masking')?.checked || false}
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        setFormState(prev =>
                                                            prev.map((f) =>
                                                                f.key === 'pii_masking'
                                                                    ? { ...f, checked: isChecked, defaultValue: isChecked ? 1 : 0 }
                                                                    : f
                                                            )
                                                        );
                                                    }}
                                                    className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                />
                                            </label>
                                        </div>

                                        {/* Enable Pre-process */}
                                        <div className="p-3 border rounded-lg bg-gray-50">
                                            <label className="flex items-center justify-between cursor-pointer">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-700">Enable Pre-processing</span>
                                                    <p className="text-xs text-gray-500 mt-1">Apply audio enhancement before diarization</p>
                                                </div>
                                                <input
                                                    type="checkbox"
                                                    checked={formState.find(f => f.key === 'enable_pre_process')?.checked || false}
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        setFormState(prev =>
                                                            prev.map((f) =>
                                                                f.key === 'enable_pre_process'
                                                                    ? { ...f, checked: isChecked, defaultValue: isChecked ? 1 : 0 }
                                                                    : f
                                                            )
                                                        );
                                                    }}
                                                    className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                />
                                            </label>
                                        </div>

                                        {/* Keep Original Language */}
                                        <div className="p-3 border rounded-lg bg-gray-50">
                                            <label className="flex items-center justify-between cursor-pointer">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-700">Keep Original Language</span>
                                                    <p className="text-xs text-gray-500 mt-1">Preserve the original language in output</p>
                                                </div>
                                                <input
                                                    type="checkbox"
                                                    checked={formState.find(f => f.key === 'keep_original_lang')?.checked || false}
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        setFormState(prev =>
                                                            prev.map((f) =>
                                                                f.key === 'keep_original_lang'
                                                                    ? { ...f, checked: isChecked, defaultValue: isChecked ? 1 : 0 }
                                                                    : f
                                                            )
                                                        );
                                                    }}
                                                    className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {/* END DIARIZATION FIELDS */}
                             
                            {/* Post Processing Config Field */}
                            {/* {(selectedProcess === 'POST_PROCESSING' || selectedProcess === 'PostProcessing') && (
                                <div className="p-3 border rounded-lg bg-gray-50 mb-3">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Text Type
                                        <p className="text-xs text-gray-500 mt-1">Select output text format</p>
                                    </label>
                                    <select
                                        value={formState.find(f => f.key === 'text_type')?.defaultValue || 'default'}
                                        onChange={(e) => {
                                            setFormState(prev =>
                                                prev.map((f) =>
                                                    f.key === 'text_type'
                                                        ? { ...f, checked: true, defaultValue: e.target.value }
                                                        : f
                                                )
                                            );
                                        }}
                                        className="block w-full rounded-md border-0 py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500"
                                    >
                                        <option value="default">Default</option>
                                        <option value="txt">Text</option>
                                        <option value="json">JSON</option>
                                    </select>
                                </div>
                            )} */}

                            {/* POST_PROCESSING Configuration Fields */}
                            {(selectedProcess === 'POST_PROCESSING' || selectedProcess === 'PostProcessing') && (
                                <div className="border-t pt-4 mt-4">
                                    <h3 className="text-sm font-medium text-gray-700 mb-3">Post-Processing Settings</h3>
                                    
                                    <div className="p-3 bg-white rounded-lg border">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Text Type
                                            <p className="text-xs text-gray-500 mt-1">Select the input text format</p>
                                        </label>
                                        <select
                                            value={formState.find(f => f.key === 'text_type')?.defaultValue || 'default'}
                                            onChange={(e) => {
                                                setFormState(prev =>
                                                    prev.map((f) =>
                                                        f.key === 'text_type'
                                                            ? { ...f, checked: true, defaultValue: e.target.value }
                                                            : f
                                                    )
                                                );
                                            }}
                                            className="block w-full rounded-md border-0 py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500"
                                        >
                                            <option value="default">Default</option>
                                            <option value="transcribed">Transcribed</option>
                                            <option value="diarized">Diarized</option>
                                        </select>
                                    </div>
                                </div>
                            )}
                            
                            {/* <form className={`space-y-3 pt-3`}>
                            {!edit && formState.length===0 && <p className="text-xs xl:text-sm p-2 bg-gray-100 rounded-lg">Please select a process</p>}
                            {(showAllFields || selectedSubCategories.length > 0 || (edit && formState.length > 0)) && formState && formState?.map((field, index) => {
                                const shouldHide =
                                selectedSubCategories.length === 0 ||
                                (field.type === 'dict' && field.nestedFields &&
                                    field.nestedFields.every(nestedField =>
                                        !nestedField.useCategory ||
                                        !nestedField.subcategoryConfig ||
                                        !Object.keys(nestedField.subcategoryConfig).some(subCatKey =>
                                            selectedSubCategories.includes(subCatKey) &&
                                            nestedField.subcategoryConfig[subCatKey]?.action === "editable"
                                        )
                                    ) &&
                                    !field.nestedFields.some(nestedField => nestedField.isEditable)
                                ) ||
                                (( !field.nestedFields || field.nestedFields.length === 0 ) &&
                                    (!field.useCategory ||
                                    !field.subcategoryConfig ||
                                    !Object.keys(field.subcategoryConfig).some(subCatKey => 
                                        selectedSubCategories.includes(subCatKey) &&
                                        field.subcategoryConfig[subCatKey]?.action === "editable"
                                    ))
                                );
                                
                                return (
                                <div key={index} className={`${!showAllFields && selectedSubCategories.length>0 && ((field.isEditable && field.isEditable===false) || shouldHide) && 'hidden'} p-3 border rounded-lg bg-gray-100 text-sm space-y-2`}>
                                <label className="block w-fit cursor-default lg:cursor-pointer" htmlFor={`check_${index}`}>
                                    {!field.required && <input
                                        id={`check_${index}`}
                                        name={`check_${index}`}
                                        type="checkbox"
                                        className="h-4 w-4 mb-0.5 me-1.5 rounded border text-indigo-600 focus:ring-gray-300 disabled:text-gray-500"
                                        checked={field.checked}
                                        disabled={field.required}
                                        onChange={() => handleCheckboxChange(index)}
                                    />}
                                    <span className={`${!field.required && 'ms-0.5'}`}>{field.alias || field.key}</span>
                                </label>            
                                {field.checked && (field.type==="dict" && (field.nestedFields && field.nestedFields.length>0)) &&
                                field.nestedFields.map((nestedfield, nestedindex) => {
                                    const hasEditableSubcategory =
                                    nestedfield.subcategoryConfig &&
                                    Object.entries(nestedfield.subcategoryConfig).some(
                                        ([key, config]) =>
                                        selectedSubCategories?.includes(key) && config.action === "editable"
                                    );
                                
                                    return (
                                    <div key={`${index}_${nestedindex}`} className={`p-3 border rounded-lg bg-white space-y-2 
                                        ${!showAllFields && !nestedfield.isEditable && !hasEditableSubcategory ? "hidden" : ""}`}>
                                    <label className="block w-fit cursor-default lg:cursor-pointer" htmlFor={`nestedcheck_${index}_${nestedindex}`}>
                                        {!nestedfield.required && <input
                                            id={`nestedcheck_${index}_${nestedindex}`}
                                            name={`nestedcheck_${index}_${nestedindex}`}
                                            type="checkbox"
                                            className="h-4 w-4 mb-0.5 me-1.5 rounded border text-indigo-600 focus:ring-gray-300 disabled:text-gray-500"
                                            checked={nestedfield.checked}
                                            disabled={nestedfield.required}
                                            onChange={() => handleNestedCheckboxChange(index, nestedindex)}
                                        />}
                                        <span className={`${!field.required && 'ms-0.5'}`}>{nestedfield.alias || nestedfield.key}</span>
                                    </label>
                                    {nestedfield.checked && (nestedfield.type==="text" || nestedfield.type==="number") && 
                                        <input
                                            type={nestedfield.type}
                                            className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                            value={nestedfield.defaultValue}
                                            onChange={(e) => handleNestedInputChange(index, nestedindex, e.target.value)}
                                            disabled={!nestedfield.checked}
                                        />
                                    }
                                    {nestedfield.checked && nestedfield.type === "boolean" && 
                                        <select
                                            className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                            value={nestedfield.defaultValue}
                                            onChange={(e) => handleNestedInputChange(index, nestedindex, e.target.value)}
                                            >
                                            <option value="true">True</option>
                                            <option value="false">False</option>
                                        </select>
                                    }
                                    {nestedfield.checked && nestedfield.type==="select" &&
                                        <select
                                            className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                            value={nestedfield.defaultValue}
                                            onChange={(e) => handleNestedInputChange(index, nestedindex, e.target.value)}
                                        >
                                            <option value="">Select an option</option>
                                            {nestedfield.options.values.map((option, optIndex) => (
                                                <option
                                                    key={`nest_${index}_${nestedindex}_${optIndex}`}
                                                    value={
                                                        nestedfield.options.captions
                                                        ? Object.values(option)[0]
                                                        : option
                                                    }
                                                >
                                                    {nestedfield.options.captions
                                                    ? Object.keys(option)[0]
                                                    : option}
                                                </option>
                                            ))}
                                        </select>
                                    }
                                    {nestedfield.checked && (nestedfield.type==="array" || (nestedfield.type==="dict")) &&
                                        <textarea
                                            className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                            value={nestedfield.defaultValue}
                                            onChange={(e) => handleNestedInputChange(index, nestedindex, e.target.value)}
                                        />
                                    }
                                    </div>
                                )})}
                                {field.checked && (field.type==="text" || field.type==="number") && 
                                    <input
                                        type={field.type}
                                        value={field.defaultValue}
                                        className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                        onChange={(e) => handleInputChange(index, e.target.value)}
                                        disabled={!field.checked}
                                    />
                                }
                                {field.checked && field.type === "boolean" && 
                                    <select
                                        className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                        value={field.defaultValue}
                                        onChange={(e) => handleInputChange(index, e.target.value)}
                                        >
                                        <option value="true">True</option>
                                        <option value="false">False</option>
                                    </select>
                                }
                                {field.checked && (field.type==="array" || (field.type==="dict" && (!field.nestedFields || field.nestedFields.length===0))) &&
                                    <textarea
                                        className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                        value={field.defaultValue}
                                        onChange={(e) => handleInputChange(index, e.target.value)}
                                    />
                                }
                                {field.checked && field.type==="select" &&
                                    <select
                                        className="block w-full rounded-md border-0 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-inset focus:ring-gray-300"
                                        value={field.defaultValue}
                                        onChange={(e) => handleInputChange(index, e.target.value)}
                                    >
                                        <option value="">Select an option</option>
                                        {field.options.values.map((option, optIndex) => (
                                            <option
                                                key={`select_${index}_${optIndex}`}
                                                value={
                                                field.options.captions
                                                    ? Object.values(option)[0]
                                                    : option
                                                }
                                            >
                                                {field.options.captions
                                                ? Object.keys(option)[0]
                                                : option}
                                            </option>
                                        ))}
                                    </select>
                                }
                                </div>
                                )})}
                            </form> */}
                            {/* <form className="space-y-3 pt-3">
                            {!edit && Array.isArray(formState) && formState.length === 0 && (
                                <p className="text-xs xl:text-sm p-2 bg-gray-100 rounded-lg">
                                Please select a process
                                </p>
                            )} */}

                            {/* {(showAllFields ||
                                (Array.isArray(selectedSubCategories) &&
                                selectedSubCategories.length > 0) ||
                                (edit && Array.isArray(formState) && formState.length > 0)) &&
                                Array.isArray(formState) &&
                                formState
                                .filter(field => field && field.key && (field.alias || field.key)) 
                                .map((field, index) => {
                                const nestedFields = Array.isArray(field.nestedFields)
                                    ? field.nestedFields
                                    : [];

                                const shouldHide =
                                    selectedSubCategories.length === 0 ||
                                    (field.type === "dict" &&
                                    nestedFields.length > 0 &&
                                    nestedFields.every(
                                        (nestedField) =>
                                        !nestedField.useCategory ||
                                        !nestedField.subcategoryConfig ||
                                        !Object.keys(nestedField.subcategoryConfig).some(
                                            (subCatKey) =>
                                            selectedSubCategories.includes(subCatKey) &&
                                            nestedField.subcategoryConfig[subCatKey]?.action ===
                                                "editable"
                                        )
                                    ) &&
                                    !nestedFields.some((nestedField) => nestedField.isEditable)) ||
                                    (nestedFields.length === 0 &&
                                    (!field.useCategory ||
                                        !field.subcategoryConfig ||
                                        !Object.keys(field.subcategoryConfig).some(
                                        (subCatKey) =>
                                            selectedSubCategories.includes(subCatKey) &&
                                            field.subcategoryConfig[subCatKey]?.action === "editable"
                                        )));

                                return (
                                    <div
                                    key={index}
                                    className={`${
                                        !showAllFields &&
                                        selectedSubCategories.length > 0 &&
                                        ((field.isEditable === false) || shouldHide) &&
                                        "hidden"
                                    } p-3 border rounded-lg bg-gray-100 text-sm space-y-2`}
                                    >
                                    <label className="block w-fit cursor-default lg:cursor-pointer">
                                        {/* {!field.required && ( */}
                                    {/*    <input
                                            type="checkbox"
                                            className="h-4 w-4 mb-0.5 me-1.5 rounded border text-indigo-600"
                                            checked={!!field.checked}
                                            disabled={!!field.required}
                                            onChange={() => handleCheckboxChange(index)}
                                        />
                                        {/* )} 
                                        <span>{field.alias || field.key}</span>
                                    </label> */}

                                    {/* ---------- NESTED FIELDS ---------- */}
                                    {/* {field.checked &&
                                        field.type === "dict" &&
                                        nestedFields.map((nestedField, nestedIndex) => {
                                        const hasEditableSubcategory =
                                            nestedField.subcategoryConfig &&
                                            Object.entries(nestedField.subcategoryConfig).some(
                                            ([key, config]) =>
                                                selectedSubCategories.includes(key) &&
                                                config.action === "editable"
                                            );

                                        return (
                                            <div
                                            key={`${index}_${nestedIndex}`}
                                            className={`p-3 border rounded-lg bg-white space-y-2 ${
                                                !showAllFields &&
                                                !nestedField.isEditable &&
                                                !hasEditableSubcategory
                                                ? "hidden"
                                                : ""
                                            }`}
                                            >
                                            <label className="block w-fit cursor-default lg:cursor-pointer">
                                                {!nestedField.required && (
                                                <input
                                                    type="checkbox"
                                                    className="h-4 w-4 mb-0.5 me-1.5 rounded border text-indigo-600"
                                                    checked={!!nestedField.checked}
                                                    disabled={nestedField.required}
                                                    onChange={() =>
                                                    handleNestedCheckboxChange(index, nestedIndex)
                                                    }
                                                />
                                                )}
                                                <span>{nestedField.alias || nestedField.key}</span>
                                            </label>

                                            {nestedField.checked &&
                                                (nestedField.type === "text" ||
                                                nestedField.type === "number") && (
                                                <input
                                                    type={nestedField.type}
                                                    className="block w-full rounded-md border py-2 text-sm"
                                                    value={nestedField.defaultValue ?? ""}
                                                    onChange={(e) =>
                                                    handleNestedInputChange(
                                                        index,
                                                        nestedIndex,
                                                        e.target.value
                                                    )
                                                    }
                                                />
                                                )}

                                            {nestedField.checked &&
                                                nestedField.type === "boolean" && (
                                                <select
                                                    className="block w-full rounded-md border py-2 text-sm"
                                                    value={nestedField.defaultValue ?? ""}
                                                    onChange={(e) =>
                                                    handleNestedInputChange(
                                                        index,
                                                        nestedIndex,
                                                        e.target.value
                                                    )
                                                    }
                                                >
                                                    <option value="true">True</option>
                                                    <option value="false">False</option>
                                                </select>
                                                )}

                                            {nestedField.checked &&
                                                nestedField.type === "select" &&
                                                Array.isArray(nestedField.options?.values) && (
                                                <select
                                                    className="block w-full rounded-md border py-2 text-sm"
                                                    value={nestedField.defaultValue ?? ""}
                                                    onChange={(e) =>
                                                    handleNestedInputChange(
                                                        index,
                                                        nestedIndex,
                                                        e.target.value
                                                    )
                                                    }
                                                >
                                                    <option value="">Select an option</option>
                                                    {nestedField.options.values.map(
                                                    (option, optIndex) => (
                                                        <option
                                                        key={`nest_${index}_${nestedIndex}_${optIndex}`}
                                                        value={
                                                            nestedField.options.captions
                                                            ? Object.values(option)[0]
                                                            : option
                                                        }
                                                        >
                                                        {nestedField.options.captions
                                                            ? Object.keys(option)[0]
                                                            : option}
                                                        </option>
                                                    )
                                                    )}
                                                </select>
                                                )}
                                            </div>
                                        );
                                        })} */}

                                    {/* ---------- MAIN FIELD INPUT ---------- */}
                                    {/* {field.checked &&
                                        (field.type === "text" || field.type === "number") && (
                                        <input
                                            type={field.type}
                                            value={field.defaultValue ?? ""}
                                            className="block w-full rounded-md border py-2 text-sm"
                                            onChange={(e) =>
                                            handleInputChange(index, e.target.value)
                                            }
                                        />
                                        )}

                                    {field.checked && field.type === "boolean" && (
                                        <select
                                        className="block w-full rounded-md border py-2 text-sm"
                                        value={field.defaultValue ?? ""}
                                        onChange={(e) =>
                                            handleInputChange(index, e.target.value)
                                        }
                                        >
                                        <option value="true">True</option>
                                        <option value="false">False</option>
                                        </select>
                                    )}

                                    {field.checked &&
                                        field.type === "select" &&
                                        Array.isArray(field.options?.values) && (
                                        <select
                                            className="block w-full rounded-md border py-2 text-sm"
                                            value={field.defaultValue ?? ""}
                                            onChange={(e) =>
                                            handleInputChange(index, e.target.value)
                                            }
                                        >
                                            <option value="">Select an option</option>
                                            {field.options.values.map((option, optIndex) => (
                                            <option
                                                key={`select_${index}_${optIndex}`}
                                                value={
                                                field.options.captions
                                                    ? Object.values(option)[0]
                                                    : option
                                                }
                                            >
                                                {field.options.captions
                                                ? Object.keys(option)[0]
                                                : option}
                                            </option>
                                            ))}
                                        </select>
                                        )}
                                    </div> */}
                                {/* );
                                })}
                            </form> */}
                            <form className="space-y-3 pt-3">
                            {!edit && Array.isArray(formState) && formState.length === 0 && (
                                <p className="text-xs xl:text-sm p-2 bg-gray-100 rounded-lg">
                                Please select a process
                                </p>
                            )}

                            {(showAllFields ||
                                (Array.isArray(selectedSubCategories) &&
                                selectedSubCategories.length > 0) ||
                                (edit && Array.isArray(formState) && formState.length > 0)) &&
                                Array.isArray(formState) &&
                                formState
                                .filter(field => {
                                    // Skip GET_IDEAS toggle fields
                                    if ((selectedProcess === 'GETIDEAS' || selectedProcess === 'GET_IDEAS') && 
                                        ['get_topics', 'get_sentiment', 'get_aliases', 'get_ner', 'get_feature_list', 'max_ideas', 'maximum_ideas', 'industry', 'company_brand_names', 'feature_lst', 'aliases']
                                        .includes(field.key)) {
                                        return false;
                                    }
                                    // Skip DIARIZATION fields
                                    if ((selectedProcess === 'DIARIZATION' || selectedProcess === 'Diarization') && 
                                        ['enable_fixes', 'process_as_wav', 'pii_masking', 'enable_pre_process', 'keep_original_lang'].includes(field.key)) {
                                        return false;
                                    }

                                    // Skip POST_PROCESSING text_type field
                                    if ((selectedProcess === 'POST_PROCESSING' || selectedProcess === 'PostProcessing') && field.key === 'text_type') {
                                        return false;
                                    }
                                    return field && field.key;
                                })
                                .map((field, index) => {
                                    // Skip invalid fields
                                    if (!field || !field.key) return null;
                                    
                                    const nestedFields = Array.isArray(field.nestedFields)
                                        ? field.nestedFields
                                        : [];

                                    // ✅ FIXED LOGIC: Check if field should be shown based on category selection
                                    const shouldHide = (() => {
                                        // If showing all fields (no categories), show everything
                                        if (showAllFields) return false;
                                        
                                        // If no subcategory selected, hide fields with useCategory
                                        if (selectedSubCategories.length === 0) {
                                            if (field.useCategory) return true;
                                            if (!field.isEditable && field.isEditable !== undefined) return true;
                                        }
                                        
                                        // Check if this field should be shown based on selected subcategory
                                        if (field.useCategory && field.subcategoryConfig) {
                                            const hasMatchingSubcategory = Object.keys(field.subcategoryConfig).some(
                                                subCatKey => selectedSubCategories.includes(subCatKey)
                                            );
                                            
                                            if (!hasMatchingSubcategory) return true;
                                            
                                            // Check if the action for selected subcategory is "editable"
                                            const selectedConfig = Object.entries(field.subcategoryConfig).find(
                                                ([key, config]) => selectedSubCategories.includes(key)
                                            );
                                            
                                            if (selectedConfig && selectedConfig[1].action === "neglect") {
                                                return true;
                                            }
                                            
                                            if (selectedConfig && selectedConfig[1].action === "editable") {
                                                return false; // ✅ Show this field
                                            }
                                        }
                                        
                                        // For dict fields with nested fields, check if any nested field should be shown
                                        if (field.type === "dict" && nestedFields.length > 0) {
                                            const hasEditableNested = nestedFields.some(nestedField => {
                                                if (nestedField.isEditable) return true;
                                                
                                                if (nestedField.useCategory && nestedField.subcategoryConfig) {
                                                    return Object.entries(nestedField.subcategoryConfig).some(
                                                        ([key, config]) =>
                                                            selectedSubCategories.includes(key) &&
                                                            config.action === "editable"
                                                    );
                                                }
                                                return false;
                                            });
                                            
                                            if (!hasEditableNested && !field.isEditable) {
                                                return true;
                                            }
                                        }
                                        
                                        // For fields without useCategory, check isEditable
                                        if (!field.useCategory && !field.isEditable && field.isEditable !== undefined) {
                                            return true;
                                        }
                                        
                                        return false;
                                    })();

                                    console.log(`Field ${field.key}: shouldHide=${shouldHide}, isEditable=${field.isEditable}, useCategory=${field.useCategory}`);

                                    return (
                                        <div
                                        key={index}
                                        className={`${shouldHide ? "hidden" : ""} p-3 border rounded-lg bg-gray-100 text-sm space-y-2`}
                                        >
                                        <label className="flex items-center w-fit cursor-pointer">
                                            <input
                                                type="checkbox"
                                                className="h-4 w-4 me-1.5 rounded border text-indigo-600 cursor-pointer focus:ring-indigo-600"
                                                checked={!!field.checked}
                                                disabled={!!field.required}
                                                onChange={() => handleCheckboxChange(index)}
                                            />
                                            <span>{field.alias || field.key}</span>
                                        </label>

                                        {/* ---------- NESTED FIELDS ---------- */}
                                        {field.checked &&
                                            field.type === "dict" &&
                                            nestedFields.map((nestedField, nestedIndex) => {
                                            const hasEditableSubcategory =
                                                nestedField.subcategoryConfig &&
                                                Object.entries(nestedField.subcategoryConfig).some(
                                                ([key, config]) =>
                                                    selectedSubCategories.includes(key) &&
                                                    config.action === "editable"
                                                );

                                            const shouldHideNested = !showAllFields && !nestedField.isEditable && !hasEditableSubcategory;

                                            return (
                                                <div
                                                key={`${index}_${nestedIndex}`}
                                                className={`p-3 border rounded-lg bg-white space-y-2 ${shouldHideNested ? "hidden" : ""}`}
                                                >
                                                <label className="flex items-center w-fit cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        className="h-4 w-4 me-1.5 rounded border text-indigo-600 cursor-pointer"
                                                        checked={!!nestedField.checked}
                                                        disabled={!!nestedField.required}
                                                        onChange={() =>
                                                        handleNestedCheckboxChange(index, nestedIndex)
                                                        }
                                                    />
                                                    <span>{nestedField.alias || nestedField.key}</span>
                                                </label>

                                                {nestedField.checked &&
                                                    (nestedField.type === "text" ||
                                                    nestedField.type === "number") && (
                                                    <input
                                                        type={nestedField.type}
                                                        className="block w-full rounded-md border py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500"
                                                        value={nestedField.defaultValue ?? ""}
                                                        onChange={(e) =>
                                                        handleNestedInputChange(
                                                            index,
                                                            nestedIndex,
                                                            e.target.value
                                                        )
                                                        }
                                                    />
                                                    )}

                                                {nestedField.checked &&
                                                    nestedField.type === "boolean" && (
                                                    <select
                                                        className="block w-full rounded-md border py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500"
                                                        value={nestedField.defaultValue ?? ""}
                                                        onChange={(e) =>
                                                        handleNestedInputChange(
                                                            index,
                                                            nestedIndex,
                                                            e.target.value
                                                        )
                                                        }
                                                    >
                                                        <option value="true">True</option>
                                                        <option value="false">False</option>
                                                    </select>
                                                    )}

                                                {nestedField.checked &&
                                                    nestedField.type === "select" &&
                                                    Array.isArray(nestedField.options?.values) && (
                                                    <select
                                                        className="block w-full rounded-md border py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500"
                                                        value={nestedField.defaultValue ?? ""}
                                                        onChange={(e) =>
                                                        handleNestedInputChange(
                                                            index,
                                                            nestedIndex,
                                                            e.target.value
                                                        )
                                                        }
                                                    >
                                                        <option value="">Select an option</option>
                                                        {nestedField.options.values.map(
                                                        (option, optIndex) => (
                                                            <option
                                                            key={`nest_${index}_${nestedIndex}_${optIndex}`}
                                                            value={
                                                                nestedField.options.captions
                                                                ? Object.values(option)[0]
                                                                : option
                                                            }
                                                            >
                                                            {nestedField.options.captions
                                                                ? Object.keys(option)[0]
                                                                : option}
                                                            </option>
                                                        )
                                                        )}
                                                    </select>
                                                    )}
                                                
                                                {nestedField.checked &&
                                                    (nestedField.type === "array" || nestedField.type === "dict") && (
                                                    <textarea
                                                        rows="3"
                                                        className="block w-full rounded-md border py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500"
                                                        value={nestedField.defaultValue ?? ""}
                                                        onChange={(e) =>
                                                        handleNestedInputChange(
                                                            index,
                                                            nestedIndex,
                                                            e.target.value
                                                        )
                                                        }
                                                    />
                                                )}
                                                </div>
                                            );
                                            })}

                                        {/* ---------- MAIN FIELD INPUT ---------- */}
                                        {field.checked &&
                                            (field.type === "text" || field.type === "number") && (
                                            <input
                                                type={field.type}
                                                value={field.defaultValue ?? ""}
                                                className="block w-full rounded-md border py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500"
                                                onChange={(e) =>
                                                handleInputChange(index, e.target.value)
                                                }
                                            />
                                            )}

                                        {field.checked && field.type === "boolean" && (
                                            <select
                                            className="block w-full rounded-md border py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500"
                                            value={field.defaultValue ?? ""}
                                            onChange={(e) =>
                                                handleInputChange(index, e.target.value)
                                            }
                                            >
                                            <option value="true">True</option>
                                            <option value="false">False</option>
                                            </select>
                                        )}

                                        {field.checked &&
                                            field.type === "select" &&
                                            Array.isArray(field.options?.values) && (
                                            <div className="space-y-2">
                                                {field.options.values.map((option, optIndex) => {
                                                    const optionValue = field.options.captions ? Object.values(option)[0] : option;
                                                    const optionLabel = field.options.captions ? Object.keys(option)[0] : option;
                                                    return (
                                                        <label key={`select_${index}_${optIndex}`} className="flex items-center gap-2 cursor-pointer">
                                                            <input
                                                                type="radio"
                                                                name={`field_${index}`}
                                                                value={optionValue}
                                                                checked={field.defaultValue === optionValue}
                                                                onChange={(e) => handleInputChange(index, e.target.value)}
                                                                className="h-4 w-4 text-indigo-600 focus:ring-indigo-600"
                                                            />
                                                            <span className="text-sm">{optionLabel}</span>
                                                        </label>
                                                    );
                                                })}
                                            </div>
                                        )}
                                        
                                        {field.checked &&
                                            (field.type === "array" || (field.type === "dict" && nestedFields.length === 0)) && (
                                            <textarea
                                                rows="3"
                                                className="block w-full rounded-md border py-2 px-3 text-sm ring-1 ring-gray-300 focus:ring-1 focus:ring-blue-500"
                                                value={field.defaultValue ?? ""}
                                                onChange={(e) =>
                                                handleInputChange(index, e.target.value)
                                                }
                                            />
                                        )}
                                        </div>
                                    );
                                })}
                            </form>
                        </div>
                    </div>
                }
            />
            <InputModal
                isOpen={isOpenStatusModal}
                closeModal={closeStatusModal}
                title={modalTitle}
                savefn={handleStatusState}
                modalInputs={
                    <div className="flex gap-5">
                        <div className="flex items-center gap-x-2">
                            <input
                                id="status"
                                name="status"
                                type="radio"
                                value="true"
                                checked={
                                    rowData.status === true ||
                                    rowData.status === "true"
                                }
                                onChange={(e) =>
                                    setRowData({
                                        ...rowData,
                                        status: e.target.value,
                                    })
                                }
                                autoFocus={false}
                                className="h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none"
                            />
                            <label
                                htmlFor="push-everything"
                                className="block text-sm font-medium leading-6 text-gray-900"
                            >
                                Active
                            </label>
                        </div>
                        <div className="flex items-center gap-x-2">
                            <input
                                id="status"
                                name="status"
                                type="radio"
                                value="false"
                                checked={
                                    rowData.status === false ||
                                    rowData.status === "false"
                                }
                                onChange={(e) =>
                                    setRowData({
                                        ...rowData,
                                        status: e.target.value,
                                    })
                                }
                                autoFocus={false}
                                className="h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none"
                            />
                            <label
                                htmlFor="push-email"
                                className="block text-sm font-medium leading-6 text-gray-900"
                            >
                                Inactive
                            </label>
                        </div>
                    </div>
                }
            />
            <div className="flex justify-between m-3 gap-2">
                <div>
                    <DebouncedInput
                        value={globalFilter ?? ""}
                        onChange={(value) => setGlobalFilter(String(value))}
                        placeholder="Search..."
                    />
                </div>
                <div className="flex gap-2">
                    <button
                        className="rounded-md cursor-default lg:cursor-pointer p-2 inline-flex text-sm border-gray-300 border"
                        onClick={() => ReloadData(true)}
                    >
                        <ArrowPathIcon className="h-5 text-green-700" />
                    </button>
                    <button
                        className="rounded-md cursor-default lg:cursor-pointer p-2 inline-flex text-sm border-gray-300 border"
                        onClick={() => openModal(null, "create")}
                    >
                        <PlusCircleIcon className="h-5" />
                    </button>
                </div>
            </div>
            {loader && <ResponseLoader msg="Fetching Params..."/>}
            {!loader && data.length===0 && <NoDataFound />}
            {!loader && data.length>0 && (
                <>
                    <div
                        ref={tableContainerRef}
                        className="resp-table-h-config border-y overflow-auto"
                    >
                        <table className="flex-inline w-full border-collapse">
                            <thead className="shadow bg-gray-100">
                                {table.getHeaderGroups().map((headerGroup) => (
                                    <tr key={headerGroup.id}>
                                        {headerGroup.headers.map((header) => {
                                            return (
                                                <th
                                                    className="border p-2 whitespace-nowrap"
                                                    key={header.id}
                                                    colSpan={header.colSpan}
                                                    style={{ width: header.getSize() }}
                                                >
                                                    {header.isPlaceholder ? null : (
                                                        <>
                                                            <div
                                                                className={`${header.column.getCanSort()
                                                                    ? "cursor-pointer select-none justify-start"
                                                                    : "justify-center"
                                                                    } flex`}
                                                                onClick={header.column.getToggleSortingHandler()}
                                                            >
                                                                {flexRender(
                                                                    header.column
                                                                        .columnDef
                                                                        .header,
                                                                    header.getContext()
                                                                )}
                                                                {{
                                                                    asc: " 🔼",
                                                                    desc: " 🔽",
                                                                }[
                                                                    header.column.getIsSorted()
                                                                ] || null}
                                                            </div>
                                                            {header.column.getCanFilter() ? (
                                                                <div className="mt-2">
                                                                    <Filter
                                                                        column={
                                                                            header.column
                                                                        }
                                                                        table={table}
                                                                    />
                                                                </div>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </th>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </thead>
                            <tbody>
                                {
                                    data.length === 0 ?
                                        (
                                            <tr>
                                                <td className='border p-2' colSpan={table.getHeaderGroups()[0].headers.length} style={{ textAlign: 'center' }}>
                                                    No Data Found
                                                </td>
                                            </tr>
                                        )
                                        :
                                        (
                                            <>
                                                {paddingTop > 0 && (
                                                    <tr>
                                                        <td
                                                            className="border p-2"
                                                            style={{ height: `${paddingTop}px` }}
                                                        />
                                                    </tr>
                                                )}
                                                {/* {(virtualRows || []).map((virtualRow) => {
                                                    const row = rows[virtualRow.index];
                                                    return (
                                                        <tr key={row.id}>
                                                            {row.getVisibleCells().map((cell) => {
                                                                return (
                                                                    <td
                                                                        className="border p-2 whitespace-nowrap"
                                                                        key={cell.id}
                                                                    >
                                                                        {flexRender(
                                                                            cell.column.columnDef.cell,
                                                                            cell.getContext()
                                                                        )}
                                                                    </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    );
                                                })} */}
                                                {(virtualRows && virtualRows.length > 0 ? virtualRows : rows.slice(0, pageSize)).map((item, index) => {
                                                    const row = virtualRows && virtualRows.length > 0 ? rows[item.index] : item;
                                                    return (
                                                        <tr key={row.id}>
                                                            {row.getVisibleCells().map((cell) => {
                                                                return (
                                                                    <td
                                                                        className="border p-2 whitespace-nowrap"
                                                                        key={cell.id}
                                                                    >
                                                                        {flexRender(
                                                                            cell.column.columnDef.cell,
                                                                            cell.getContext()
                                                                        )}
                                                                    </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    );
                                                })}
                                                {paddingBottom > 0 && (
                                                    <tr>
                                                        <td
                                                            className="border p-2"
                                                            style={{ height: `${paddingBottom}px` }}
                                                        />
                                                    </tr>
                                                )}
                                            </>
                                        )
                                }
                            </tbody>
                        </table>
                    </div>
                    {
                        rows.length > 0 &&
                        (
                            <div className="flex gap-1 flex-wrap md:flex-nowrap justify-between flex-row-reverse m-3">
                                {/* <nav
                                    className="isolate inline-flex -space-x-px mx-2 md:m-0 bg-white rounded-md md:shadow-sm text-gray-900"
                                    aria-label="Pagination"
                                >
                                    <button
                                        title="First Page"
                                        onClick={() => setPageIndex(0)}
                                        className="relative inline-flex items-center rounded-l-md px-2 py-2 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                                    >
                                        <ChevronDoubleLeftIcon
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                        />
                                    </button>
                                    <button
                                        title="Previous Page"
                                        onClick={() => setPageIndex(pageIndex - 1)}
                                        disabled={pageIndex === 0}
                                        aria-current="page"
                                        className="relative inline-flex items-center px-2 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                                    >
                                        <ChevronLeftIcon
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                        />
                                    </button>
                                    {pageNumbers.length === 1 &&
                                        <button
                                            className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
                                            key={1}
                                            onClick={() => setPageIndex(0)}
                                        >
                                            {1}
                                        </button>
                                    }
                                    {pageNumbers.length > 1 && pageNumbers.map((pageNumber, index) => {
                                        if (pageNumber === 0 || pageNumber === table.getPageCount() - 1 || Math.abs(pageNumber - pageIndex) <= 1) {
                                            if (table.getPageCount() !== 0 && table.getPageCount() === 1 && table.getPageCount() === pageNumber) {
                                                return (
                                                    <button
                                                        className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
                                                        key={index}
                                                        onClick={() => setPageIndex(pageNumber - 1)}
                                                    >
                                                        {pageNumber}
                                                    </button>
                                                );
                                            }
                                            else if (table.getPageCount() !== 1 && table.getPageCount() > pageNumber) {
                                                return (
                                                    <button
                                                        className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
                                                        key={index}
                                                        onClick={() => setPageIndex(pageNumber)}
                                                    >
                                                        {pageNumber + 1}
                                                    </button>
                                                );
                                            }
                                            else if (table.getPageCount() === 0 && table.getPageCount() === pageNumber) {
                                                return (
                                                    <button
                                                        className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
                                                        key={index}
                                                        onClick={() => setPageIndex(0)}
                                                    >
                                                        {1}
                                                    </button>
                                                );
                                            }
                                        } else if (pageNumber === 1 || pageNumber === table.getPageCount() - 2) {
                                            return <button className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0' key={index}>...</button>;
                                        }
                                        return null;
                                    })}
                                    <button
                                        title="Next Page"
                                        onClick={() => setPageIndex(pageIndex + 1)}
                                        disabled={pageIndex === table.getPageCount() - 1}
                                        className="relative inline-flex items-center px-2 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                                    >
                                        <ChevronRightIcon
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                        />
                                    </button>
                                    <button
                                        title="Last Page"
                                        onClick={() => setPageIndex(table.getPageCount() - 1)}
                                        className="relative inline-flex items-center rounded-r-md px-2 py-2 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                                    >
                                        <ChevronDoubleRightIcon
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                        />
                                    </button>
                                </nav> */}
                                <Pagination
                                    pageIndex={pageIndex}
                                    setPageIndex={setPageIndex}
                                    pageNumbers={pageNumbers}
                                    pageCount={table.getPageCount()}
                                />
                                <PageSizeDropdown
                                    dataLength={table.getPrePaginationRowModel().rows.length}
                                    pageSize={pageSize}
                                    handlePageChange={handlePageChange}
                                    totalRows={table.getPrePaginationRowModel().rows.length}
                                />
                            </div>
                        )
                    }
                </>
            )}
        </div>
    );
}